export const zhLangDashboard = {
  headerSearch: {
    placeholder: '搜索商品',
    cancel: '取消',
    empty: '未找到商品',
    noShop: '暂无可搜索的商品',
  },
  adminUi: {
    podcastEnterShowTitle: '输入节目标题',
    podcastMaximum: '最多',
    podcastCharacters: '个字符',
    podcastShowTitleExists: '已存在同名节目',
    podcastEditShow: '编辑节目',
    podcastNewShow: '新建节目',
    podcastCover: '封面',
    podcastTitle: '标题',
    podcastShowTitlePlaceholder: '节目标题',
    podcastCategory: '分类',
    podcastCategoryPlaceholder: '例如：真实犯罪',
    podcastDescription: '描述',
    podcastDescriptionPlaceholder: '这个节目讲什么…',
    podcastSubscribeButtons: '“订阅”按钮',
    podcastAddPlatform: '添加平台',
    podcastSave: '保存',
    podcastCreate: '创建',
    episodeOne: '集',
    episodeFew: '集',
    episodeMany: '集',
    edit: '编辑',
    delete: '删除',
    addShow: '添加节目',
    importFromRss: '从 RSS 导入',
    importFromRssFeed: '从 RSS 源导入',
    importFromRssHint: '粘贴播客 RSS 链接，剧集将自动导入到新节目中。',
    import: '导入',
    trackWordOne: '首',
    trackWordFew: '首',
    trackWordMany: '首',
    albumLabel: '专辑',
    pause: '暂停',
    play: '播放',
    emptyTracks: '此专辑暂无曲目',
    untitled: '未命名',
    show: '节目',
    audioFileNotAttached: '未附加音频文件',
    paypalConnectionTitle: '选择 PayPal 连接方式',
    paypalConnectionSubtitle: '选择最方便的连接方式',
    paypalRecommendedBadge: '推荐',
    paypalPartnerTitle: '通过 PayPal 合作伙伴',
    paypalPartnerFeatureQuickConnect: '一键快速连接',
    paypalPartnerFeatureAutoTokens: '自动刷新令牌',
    paypalPartnerFeatureMostSecure: '最安全的方式',
    paypalPartnerFeatureNoApiKeys: '无需复制 API 密钥',
    paypalPartnerButton: '通过合作伙伴连接',
    paypalDirectTitle: '直接连接（API 凭据）',
    paypalDirectFeatureClientIdSecret: '需要 Client ID 和 Secret',
    paypalDirectFeatureManualSetup: '手动设置',
    paypalDirectFeatureFullControl: '完全掌控 API',
    paypalDirectFeatureAdvancedUsers: '适合高级用户',
    paypalDirectButton: '直接连接',
    clientIdRequired: 'Client ID 为必填项',
    clientSecretRequired: 'Client Secret 为必填项',
    invalidPaypalCredentials: 'PayPal 凭据无效',
    connectPaypalDirectly: '直接连接 PayPal',
    paypalConnectedSuccessfully: 'PayPal 连接成功！',
    yourPaypalClientId: '来自 Dashboard 的 PayPal Client ID',
    yourPaypalClientSecret: '来自 Dashboard 的 PayPal Client Secret',
    chooseOperatingMode: '选择运行模式',
    sandboxTest: 'Sandbox（测试）',
    liveProduction: 'Live（生产）',
    whereToFindCredentials: '💡 在哪里找到凭据？',
    goTo: '前往',
    createOrSelectApp: '新建或选择一个 App',
    copyClientIdAndSecret: '复制 Client ID 和 Secret',
    cancel: '取消',
    connected: '已连接！',
    connect: '连接',
    monobankTokenTooltip: '来自 Monobank 商业收单的令牌',
    monobankTokenPlaceholder: '输入 Monobank 令牌',
    whereToGetToken: '在哪里获取令牌？',
    statusChangedTo: '状态已更改为',
    all: '全部',
    loading: '加载中...',
    noBookingsYet: '暂无预订',
    noBookingsWithStatus: '没有此状态的预订',
    nightsAbbr: '晚',
    uah: 'UAH',
    oneNightDeposit: '一晚押金',
    fullPrepayment: '全额预付',
    online: '在线',
    confirm: '确认',
    complete: '完成',
    restore: '恢复',
    bookingCalendarBooked: '已预订',
    bookingCalendarBlockedManually: '手动锁定',
    bookingCalendarAvailable: '可预订',
    bookingCalendarNoSettings: '无设置',
    bookingCalendarSaveItemFirst: '请先保存项目',
    bookingCalendarLoading: '加载中...',
    bookingCalendarBlocked: '已锁定',
    bookingCalendarSelected: '已选择',
    bookingCalendarSelectedDates: '已选日期',
    bookingCalendarPricePerDay: '每日价格',
    bookingCalendarOpen: '开放',
    bookingCalendarBlock: '锁定',
    bookingCalendarCancel: '取消',
    responseDeleted: '回复已删除',
    deleteAllConfirm: '删除所有回复？此操作无法撤销。',
    allResponsesDeleted: '所有回复已删除',
    responseOne: '条回复',
    responseFew: '条回复',
    responseMany: '条回复',
    deleteAll: '全部删除',
    allForms: '所有表单',
    noResponsesYet: '暂无回复',
    fieldName: '姓名',
    fieldPhone: '电话',
    fieldAddress: '地址',
    fieldComment: '备注',
    customFields: '附加字段',
    more: '更多',
    view: '查看',
    track: '跟踪',
    showing: '显示',
    of: '共',
    ordersLower: '订单',
    ordersEmpty: '暂无记录',
    ordersCountLabel: '条记录',
    ordersName: '姓名',
    ordersPhone: '电话',
    ordersLoading: '加载中...',
    ordersComment: '备注',
    ordersPayment: '支付',
    ordersPrev: '上一页',
    ordersNext: '下一页',
    revokeAccessConfirm: '撤销访问权限？',
    accessRevoked: '访问权限已撤销',
    activeGrants: '个有效授权',
    noActiveGrants: '无有效授权',
    type: '类型',
    grantedBy: '授权人',
    started: '开始',
    until: '截至',
    revoke: '撤销',
    deleted: '已删除',
    subscribers: '订阅者',
    noSubscribersYet: '暂无订阅者',
    phone: '电话',
    name: '姓名',
    step: '步骤',
    done: '完成',
    stepFailedSingular: '步失败',
    stepFailedPlural: '步失败',
    done2: '完成。',
    actionFailed: '操作执行失败。',
    starterCoffeeSite: '为咖啡店做一个网站',
    starterFaq: '添加一个含 5 个问题的 FAQ 板块',
    starterTranslate: '将整个网站翻译成英文',
    starterBrandColors: '挑选符合我品牌的配色',
    stopped: '已停止。',
    scopeSite: '网站',
    scopePage: '页面',
    followUpAddPhoto: '再加一张照片',
    followUpAddQuestion: '再加一个问题',
    followUpAddPlan: '再加一个价格方案',
    followUpAddService: '再加一项服务',
    followUpAddBlock: '再加一个板块',
    followUpMakeBetter: '做得更好一些',
    followUpTweakColors: '调整配色以匹配我的品牌',
    followUpChangeColors: '更改配色',
    followUpTranslateEnglish: '翻译成英文',
    undoneDeletedPrefix: '已撤销 — 移除了',
    undoneOf: '共',
    undoneCreatedBlocks: '个已创建的板块',
    planAnalyzing: '正在分析请求',
    planCheckingSite: '正在检查网站状态',
    planChoosingBlocks: '正在选择板块',
    planPreparing: '正在准备方案',
    hideDetails: '隐藏详情',
    details: '详情',
    emptyStateTitle: '需要什么帮助？',
    emptyStateSubtitle: '描述你想做的事，或从下方选一个示例',
    undoing: '撤销中…',
    undo: '撤销',
    blockSingular: '个板块',
    blockPlural: '个板块',
    usageCostTitle: '本次请求费用',
    tokens: 'tokens',
    stop: '停止',
    scopeSiteTitle: '在整个网站范围内更改',
    scopePageTitle: '仅在当前页面更改',
    customDesign: '自定义设计',
    appointmentEmbedTitle: '嵌入 URL',
    appointmentEmbedSubtitle: '以内联 iframe 方式嵌入 Calendly',
    appointmentEmbedCaption: 'Calendly URL',
    appointmentEmbedTooltip: '粘贴你的 Calendly 活动链接（例如 https://calendly.com/you/30min）',
    appointmentEmbedInvalid: '请输入有效的 Calendly 链接（例如 https://calendly.com/you/30min）',
  },
  ama: {
    questions: '问题',
    all: '全部',
    unanswered: '未回答',
    answered: '已回答',
    loading: '加载中...',
    noQuestions: '暂无问题',
    anonymous: '匿名',
    noName: '无姓名',
    yourAnswer: '你的回答',
    edit: '编辑',
    delete: '删除',
    cancel: '取消',
    enterAnswer: '输入你的回答...',
    saveAnswer: '保存回答',
    confirmDelete: '删除这个问题？',
    answerSaved: '回答已保存',
    deleted: '已删除',
  },
  adsManager: {
    estimatedAudience: '预估受众规模',
    audienceTooLarge: '你的受众范围很广，建议适当缩小。',
    audienceTooNarrow: '你的受众范围很小，建议适当扩大。',
    audience: '受众',
    suggestedAudience: '使用建议受众',
    suggestedAudienceHint: '宽泛定向，最适合扩大触达',
    buildYourOwn: '自定义',
    buildYourOwnHint: '设置年龄、性别和国家/地区',
    expectedViewers: '预计广告观看人数',
    totalBudget: '广告系列总预算',
    duration: '时长',
    days: '天',
    advancedSchedule: '高级排期',
    hideAdvanced: '隐藏高级排期',
    adPreview: '广告预览',
    sponsored: '赞助',
    seeMore: '查看更多',
    learnMore: '了解更多',
    yourPage: '你的主页',
  },
  pinnedDock: {
    title: '置顶板块',
    label: '已置顶',
    expand: '展开置顶板块',
    collapse: '收起置顶板块',
  },
  reviewButton: {
    title: '留下评价按钮',
    desc: '在评价下方显示一个按钮，引导访客前往留下评价。',
    buttonText: '按钮文字',
    link: '链接',
    leaveReview: '留下评价',
    googleHint: '留空则使用你的 Google 评价页面。',
    design: '按钮设计',
    background: '背景',
    textColor: '文字',
  },
  common: {
    you: '你',
    post: '帖子',
    article: '文章',
    create: '创建',
    message: '消息',
    popular: '热门',
    emptyIntegrations: '你需要先添加集成',
    categories: '分类',
    edit: '编辑',
    share: '分享',
    plan: '方案',
    sort: '排序',
    addArticle: '添加文章',
    articles: '文章',
    users: '用户',
    scans: '次扫描',
    clicks: '次点击',
    copy: '复制',
    customize: '自定义',
    link: '链接',
    save: '保存',
    uploadFile: '上传文件',
    customImage: '自定义图片',
    customImageTooltip: '上传自定义图片',
    size: '尺寸',
    sizeTooltip: '拖动滑块设置尺寸',
    auto: '自动',
    rectangle: '矩形',
    custom: '自定义',
    clean: '清除',
    cleaning: '清除中',
    download: '下载',
    downloading: '下载中',
    preview: '预览',
    cover: '封面',
    coverTooltip: '上传封面图片',
    title: '标题',
    new: '新',
    pro: 'Pro',
    free: '免费',
    limit: '上限',
    websites: '个网站',
    site: '网站',
    apiKey: 'API 密钥',
    name: '名称',
    passwordChange: '修改密码',
    draft: '草稿',
    page: '页面',
    areYouSure: '确定吗？',
    drop: '拖放',
    video: '视频',
    image: '图片',
    chooseFile: '选择文件',
    nothingFound: '未找到内容',
    enterCorrectLink: '请输入正确的链接',
    off: '关闭',
    disconnect: '断开连接',
    connect: '连接',
    copied: '已复制',
    saved: '已保存',
    lostConnection: '连接已断开',
    addedCategory: '已添加分类',
    none: '无',
    left: '左',
    right: '右',
    thin: '细',
    solid: '实线',
    double: '双线',
    welcome: '欢迎',
    category: '分类',
    product: '商品',
    website: '网站',
    items: '项目',
    square: '方形',
    round: '圆形',
    border: '边框',
    shadow: '阴影',
    subtle: '轻微',
    soft: '柔和',
    hard: '硬朗',
    block: '板块',
    primary: '主要',
    additional: '附加',
    normal: '常规',
    bold: '粗体',
    uploadVideo: '上传视频',
    compact: '紧凑',
    card: '卡片',
    top: '顶部',
    center: '居中',
    bottom: '底部',
    button: '按钮',
    addNewItem: '添加新项目',
    blockEmptyTitle: '这里还什么都没有',
    blockEmptyText: '此板块暂无项目。添加一项即可在页面上显示。',
    noItemsTitle: '你还没有任何项目',
    noItemsText: '添加第一个项目来填充此板块。',
    price: '价格',
    priceCaption: '添加商品价格',
    oldPrice: '原价',
    oldPriceCaption: '原价将显示删除线',
    areYouSureDeleteItem: '确定要删除这个项目吗？',
    add: '添加',
    active: '启用',
    isActive: '已启用',
    isDisabled: '已禁用',
    uploadImage: '上传图片',
    design: '设计',
    addAccount: '添加账户',
    hey: '嗨',
    activeBackground: '选中背景',
    activeText: '选中文字',
    connectDomain: '连接域名',
    shortLink: '短链接',
    appearanceSaved: '外观已保存！',
    blockAdded: '板块已添加！',
    comingSoon: '即将推出',
    easyMoney: '轻松赚钱',
    content: '内容',
    audience: '受众',
    view: '查看',
    delete: '删除',
    file: '文件',
    type: '类型',
    from: '起始',
    to: '结束',
    fullName: '全名',
    lastTimeUsed: '上次使用',
    noMediaFiles: '暂无媒体文件...',
    withdraw: '提现',
    congrats: '恭喜！',
    makeMoneyOnline: '在线赚钱！',
  },
  sort: {
    title: '排序',
    search: '搜索',
    default: '默认排序',
    dateNew: '日期：从新到旧',
    dateOld: '日期：从旧到新',
    priceLow: '价格：从低到高',
    priceHigh: '价格：从高到低',
    nameA: '名称：A 到 Z',
    nameZ: '名称：Z 到 A',
    popular: '最热门',
  },
  emailMenu: {
    broadcasts: '群发',
    automations: '自动化',
    templates: '模板',
    settings: '设置',
    noEmails: '暂无邮件',
    newBroadcast: '新建群发',
  },
  aiContent: {
    title: '创建你的第一个 AI 内容！',
    text: '一次性规划并发布内容到所有社交媒体！',
    create: '创建 AI 内容',
  },
  pageDesign: {
    page: '页面设计',
    image: '图片',
  },
  toolsMenu: {
    title: '工具',
    account: '账户',
    instantPages: '即时页面',
    instantPagesText: '加载迅速的独立页面',
    agents: '智能助手',
    agentsText: '管理你主页的 AI 助手',
    socialPlanner: '社交规划器',
    socialPlannerText: '内容排期与灵感',
    emailMarketing: '邮件营销',
    emailMarketingText: '扩大你的联系人列表',
    smartReply: 'Instagram 回复',
    smartReplyText: '自动发送评论和私信',
    linkShortener: '短链接',
    linkShortenerText: '把长链接变短',
    posts: '帖子',
    postsText: '创建和管理帖子',
    blog: '博客',
    blogText: '创建和管理博客文章',
  },
  insideMenu: {
    planner: '规划器',
    aiContent: 'AI 内容',
    aiPosts: 'AI 帖子',
    postIdeas: '帖子灵感',
    contentPlanner: '内容规划器',
    aiImages: 'AI 图片',
    adBuilder: '广告构建器',
    brandProjects: 'Brand Identity',
    aiVideo: 'AI 视频',
    integrations: '集成',
    products: '商品',
    orders: '订单',
    payments: '支付',
    links: '链接',
    qrCodes: '二维码',
  },
  orders: {
    title: '订单',
    empty: '你还没有任何订单',
    all: '所有订单',
    shop: '商店',
    digital: '数字商品',
    appointments: '预约',
    services: '服务',
    donations: '捐赠',
  },
  discounts: {
    title: '折扣',
    newDiscount: '+ 新建折扣',
    code: '代码',
    titleCol: '标题',
    type: '类型',
    value: '数值',
    status: '状态',
    used: '已使用',
    actions: '操作',
    statusAll: '所有状态',
    statusActive: '生效中',
    statusExpired: '已过期',
    statusScheduled: '已排期',
    statusInactive: '未启用',
    searchPlaceholder: '按代码或标题搜索...',
    clearFilters: '清除筛选',
    emptyTitle: '暂无折扣',
    emptySubtitle: '创建你的第一个优惠码，为商品提供折扣',
    createDiscount: '创建折扣',
    createTitle: '创建折扣',
    editTitle: '编辑折扣',
    fieldTitle: '标题',
    fieldTitlePlaceholder: '例如：春季促销',
    fieldCode: '代码',
    fieldCodePlaceholder: '例如：SAVE20',
    generate: '生成',
    sectionDiscount: '折扣',
    fieldTrigger: '如何生效',
    triggerCode: '折扣码',
    triggerAutomatic: '自动（无需代码）',
    triggerAutomaticHint: '满足条件时在结账时自动生效，无需代码。在下方设置最低订单金额可创建按订单金额的折扣。',
    automaticBadge: '自动',
    fieldType: '类型',
    typePercentage: '百分比',
    typeFixed: '固定金额',
    typeFreeShipping: '免运费',
    fieldValue: '数值',
    sectionConditions: '条件（可选）',
    appliesTo: '适用于',
    appliesToAll: '所有商品',
    appliesToShop: '商店',
    appliesToDigital: '数字商品',
    appliesToCourses: '课程',
    appliesToServices: '服务',
    appliesToEvents: '活动',
    minOrderAmount: '最低订单金额（$）',
    maxDiscountAmount: '最高折扣金额（$）— 0 表示无上限',
    minItemCount: '订单最低商品数量 — 0 表示无要求',
    specificProducts: '指定商品 — 留空表示全部适用',
    specificProductsPlaceholder: '搜索商品...',
    noProductsFound: '未找到商品',
    sectionLimits: '限制',
    usageLimit: '总使用次数上限 — 0 表示无限',
    usageLimitPerUser: '每位客户使用上限 — 0 表示无限',
    sectionSchedule: '排期',
    startDate: '开始日期 — 留空表示立即开始',
    endDate: '结束日期 — 留空表示永不过期',
    active: '启用',
    cancel: '取消',
    save: '保存折扣',
    createdSuccess: '折扣已创建',
    updatedSuccess: '折扣已更新',
    deletedSuccess: '折扣已删除',
    loadError: '加载折扣失败',
    saveError: '保存折扣失败',
    deleteError: '删除折扣失败',
  },
  donation: {
    chooseSmiles: '选择表情',
    item: '项目',
    itemTitle: '捐赠项目标题',
    price: '价格',
    thanksMessagePlaceholder: '非常感谢',
    thanksMessage: '感谢消息',
    thanksMessageCaption: '捐赠后将向你的粉丝显示感谢消息',
    addDonation: '添加捐赠',
    addAmount: '+ 添加金额',
    buttonTitle: '按钮标题',
    buttonTitleCaption: '捐赠按钮的标题',
    acceptDonations: '接受捐赠',
    donationsType: '捐赠',
    tips: '打赏',
    type: '类型',
    addAnotherAmount: '+ 添加另一个金额',
  },
  blog: {
    empty: '你还没有博客',
  },
  apps: {
    empty: '你还没有应用',
  },
  payments: {
    title: '支付',
    text: '你还没有任何交易',
    single: '单笔支付',
    subscriptions: '订阅',
    wallet: '钱包',
    connectPromo: '将 Stripe 或 PayPal 账户连接到你的 UniLink 页面，所有款项都会进入你的钱包。',
    connectSystem: '连接支付系统',
    manageCards: '管理你的卡片',
    addNewCard: '添加新卡',
    editCard: '编辑卡片信息',
    addCard: '添加卡片信息',
    cardHolder: '持卡人姓名',
    cardHolderNecessary: '此项为必填',
    withdrawalSuccess: '你的提现申请已成功提交！',
    withdrawalError: '出错了，请稍后再试。',
    change: '更改',
  },
  store: {
    emptyTitle: '你还没有任何商品',
    emptyText: '先添加你的第一个商品',
    emptyButton: '添加商品',
    createFirstProduct: '创建你的第一个商品',
    startAdding: '先添加你喜爱的商品、数字产品或服务。一个可以销售和推广你所有产品的空间。',
    activate: '启用商店',
    empty: '你还没有商品',
    products: '商品',
    addProducts: '添加商品',
    whatDoYouWant: '你想卖什么？',
    externalProduct: '外部商品 URL',
    createOwnProduct: '创建你自己的商品',
    shop: '商店',
    shopText: '销售实体和数字商品',
    digital: '数字商品',
    digitalText: '销售数字下载内容',
    course: '课程或教程',
    courseText: '为网站添加课程或教程',
    service: '服务',
    serviceText: '为客户添加服务',
    appointment: '预约',
    appointmentText: '让访客在你的日历上预约时间',
    event: '活动或门票',
    eventText: '创建活动并邀请受众',
    tips: '打赏',
    tipsText: '为你喜爱的创作者打赏',
    donation: '捐赠',
    donationText: '进行捐赠',
    membership: '会员',
    membershipText: '为网站添加会员功能',
    links: '外部链接',
    linksText: '添加指向任意网站的外部链接',
    coupon: '优惠券',
    couponText: '为你的网站添加优惠券',
    singleProduct: '单个商品',
    singleProductText: '以简单结账流程销售单个商品',
    booking: '预订',
    bookingText: '让访客预订你的空间或房产',
    rental: '租赁',
    rentalText: '列出租赁物品及其可用性和价格',
    add: '添加',
    manageStore: '管理商店',
    displayLast: '显示最新商品',
  },
  products: {
    info: '信息',
    uploadCover: '上传封面图片，然后填写标题和描述',
    thumbnail: '缩略图',
    thumbnailError: '请添加缩略图',
    title: '标题',
    titleTooltip: '输入你的商品名称',
    shortDescription: '简短描述',
    shortDescriptionTooltip: '输入你商品的简短描述',
    description: '描述',
    descriptionTooltip: '输入你商品的描述',
    descriptionTooltipExtra: '可选：对商品特性、类型、颜色、尺寸等的描述。',
    price: '价格',
    priceTooltip: '输入你的商品价格',
    oldPrice: '原价',
    oldPriceTooltip: '原价将显示删除线',
    category: '分类',
    categoryTooltip: '选择你的商品分类',
    image: '图片',
    imageTooltip: '为你的商品上传图片',
    groups: '分组',
    rate: '评分',
    rateTooltip: '输入你的商品评分',
    buttonTitle: '按钮标题',
    buttonTitleTooltip: '输入你商品按钮的标题',
    features: '特性',
    featuresTooltip: '在展示卡片布局中显示的卖点清单',
    featurePlaceholder: '卖点',
    addFeature: '添加特性',
    limitQuantity: '限制数量',
    itemsLeft: '剩余数量',
    itemsLeftTooltip: '你商品的库存数量',
    trackStock: '跟踪数量',
    stockQuantity: '库存数量',
    stockQuantityTooltip: '当前库存数量。每笔付款订单会自动减少；降至 0 时该商品将无法购买。',
    lowStockThreshold: '低库存提醒',
    lowStockThresholdTooltip: '当库存降至此数量或以下时接收通知。',
    maxOrderQuantity: '最大订购数量',
    maxOrderQuantityTooltip: '客户单次订单可购买的最大数量。留空表示无限制。',
    minOrderQuantity: '最小订购数量',
    minOrderQuantityTooltip: '客户单次订单必须购买的最小数量。留空表示无限制。',
    pendingReviews: {
      title: '待审核评价',
      subtitle: '在买家评价公开前批准或隐藏',
      empty: '没有待审核的评价。',
      approve: '批准',
      hide: '隐藏',
    },
    attachments: '附件',
    addAttachments: '为你的商品添加附件',
    addNewAttachment: '添加新项目',
    file: '文件',
    uploadFile: '上传文件',
    uploadCoverTitle: '上传封面',
    optionalDescription: '可选：对商品特性、类型、颜色、尺寸等的描述。',
    customReviews: '自定义评价',
    addCustomReviews: '为你的商品添加评价',
    name: '姓名',
    nameTooltip: '输入客户姓名',
    comment: '评论',
    commentTooltip: '输入客户评论',
    rateTooltipCustomer: '客户评分',
    imageTooltipCustomer: '上传客户图片',
    displayPriceOnPreview: '在预览中显示价格',
    displayDetailsOnPreview: '在预览中显示详情',
    postOnSocials: '发布到社交媒体',
    sendAnEmail: '发送邮件',
    highlights: '亮点',
    listProductSetup: '上架商品并设置你的商店板块',
    whereToSell: '你想在哪里销售此商品？',
    youHaveProducts: '你有 {count} 个商品',
    shareThisProduct: '分享此商品',
    shareAProduct: '分享商品',
    monetizeWays: '在 UniLink 上变现的多种方式',
    addProductToProfile: '将 {title} 添加到你的主页',
    productPage: '商品页面',
    setUpPayments: '设置你的支付方式',
    connectPaymentMethods: '连接你的支付方式，开始在 UniLink 上赚钱',
    addPaymentMethod: '添加 {type} 支付方式以接收粉丝付款',
    withdrawAttempt: '这是一次债务催收尝试，任何信息都将用于此目的。',
    withdrawSuccess: '你的提现申请已成功提交！',
    yourVisitorsPay: '访客将先付款，然后被引导至你的 {method}',
    emailAddress: '电子邮箱地址',
    calendlyLink: 'Calendly 链接',
  },
  posts: {
    posts: '帖子',
    title: '创建你的第一篇帖子',
    description: '帖子让你以简单直观的方式创建聊天自动化。试试我们根据你的目标推荐的一些自动化。',
    activate: '启用帖子',
    managePosts: '管理帖子',
    postsTab: '帖子标签页',
    displayLast: '显示最新帖子',
    tabNavigation: '标签导航设置',
    createFirstPost: '创建你的第一篇社交帖子！',
    autoPostsText: '一次性规划并发布内容到所有社交媒体！',
    createPost: '创建帖子',
  },
  messages: {
    title: '消息',
    empty: '暂无消息',
    addText: '在 Header 板块添加消息按钮，让用户可以轻松给你发消息。',
    addButton: '添加消息按钮',
  },
  smartReply: {
    title: 'Instagram 回复',
    clicks: '次点击',
    createTitle: '创建你的第一个 Instagram 回复！',
    text: '使用 Instagram 自动私信，自动向你的受众分享链接！',
    createButton: '创建自动私信',
    subtitleComment: '回复评论时自动发送带链接的私信',
    subtitleDm: '回复消息或 Story 时自动发送私信',
    ready: '就绪',
    edit: '编辑',
    stepContentTitle: 'IG 内容',
    stepContentSub: '选择一个帖子或 Reel',
    storiesAndDmsSub: '当有人回复 Story 或给你收件箱发消息时自动私信',
    stepTriggerTitle: '触发条件',
    stepTriggerSub: '评论中的关键词',
    stepTriggerSubDm: '消息中的关键词',
    stepDmTitle: '私信',
    stepDmSub: '自动发送的消息',
    dmSummary: '消息已设置',
    activatesNow: '自动回复将立即生效',
    saveAutomation: '保存自动回复',
    savedToast: '自动回复已创建',
    linkLabel: '选择链接目标',
    selectDestination: '选择一个链接、商品或文章',
    change: '更改',
    choose: '选择',
    remove: '移除',
    optional: '可选',
    buttonText: '按钮文字',
    addLink: '添加链接',
    attachLink: '附加链接',
    noLinks: '暂无链接 — 请先在你的 Link in Bio 中添加链接。',
    tabLinks: '链接',
    tabProducts: '商品',
    noProducts: '暂无商品 — 请先在你的商店中创建商品。',
    tabArticles: '文章',
    noArticles: '暂无文章 — 请先创建文章。',
    choosePost: '选择一个帖子或 Reel',
    searchPosts: '搜索你的帖子',
    loadingPosts: '正在加载你的帖子…',
    done: '完成',
    oneSelected: '已选择 1 个帖子',
    postSelected: '帖子已选择',
    noPosts: '暂无帖子 — 请在 Instagram 上发布帖子或 Reel。',
    postsError: '无法加载帖子，请重试。',
    reauthTitle: '部分私信可能无法送达。',
    reauthText: 'Instagram 要求你重新授权该账户。',
    reconnect: '重新连接',
    statActive: '已启用的自动化',
    statDmSent: '已发私信 · 30 天',
    statClicks: '链接点击',
    activeReplies: '已启用的自动回复',
    filterAll: '全部',
    filterActive: '已启用',
    filterOff: '已关闭',
  },
  virtualBackgrounds: {
    title: '虚拟背景',
    canvasSize: '画布尺寸',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: '方形',
    fmtClassic: '经典',
    background: '背景',
    bg_color: '颜色',
    bg_gradient: '渐变',
    bg_photo: '照片',
    bg_pattern: '图案',
    from: '起始色',
    to: '结束色',
    angle: '角度',
    ink: '墨色',
    paper: '纸色',
    blur: '模糊',
    darken: '变暗',
    presets: '预设',
    uploadImage: '上传图片',
    removeImage: '移除图片',
    replace: '替换',
    remove: '移除',
    photoPlaceholder: '从面板上传图片',
    overlay: '叠加层',
    showName: '显示姓名',
    namePlaceholder: '你的姓名',
    subtitlePlaceholder: '副标题 / 用户名',
    typeface: '字体',
    textColour: '文字颜色',
    nameSizeLabel: '姓名字号',
    position: '位置',
    showQr: '显示二维码',
    qrPlaceholder: 'https://link',
    style: '样式',
    qrCard: '卡片',
    qrBrand: '品牌',
    qrLight: '浅色',
    qrSolid: '纯色',
    qrSizeLabel: '二维码尺寸',
    logo: 'Logo / 头像',
    uploadLogo: '上传 Logo（PNG）',
    logoSizeLabel: 'Logo 尺寸',
    finishing: '润色',
    vignette: '暗角',
    vignetteHint: '柔和的暗边营造层次感',
    shuffle: '随机',
    reset: '重置',
    dragHint: '在画布上拖动姓名、二维码或 Logo 以重新定位',
    preparing: '准备中…',
    download: '下载',
    sizeHint: '保存为 1920 × 1080 JPG',
  },
  emailSignatures: {
    title: '邮件签名',
    details: '详情',
    name: '姓名',
    jobTitle: '职位',
    company: '公司',
    email: '邮箱',
    phone: '电话',
    website: '网站',
    style: '样式',
    styleModern: '现代',
    styleClassic: '经典',
    styleMinimal: '极简',
    styleBold: '醒目',
    styleCard: '卡片',
    accent: '强调色',
    showAvatar: '显示照片',
    showQr: '显示二维码',
    preview: '预览',
    copySignature: '复制签名',
    copyHtml: '复制 HTML',
    copied: '签名已复制',
    copiedHtml: 'HTML 已复制',
    instructions: {
      gmail: 'Gmail：设置 → 查看所有设置 → 常规 → 签名 → 新建，然后粘贴（Ctrl/Cmd+V）并保存更改。',
      outlook: 'Outlook：文件 → 选项 → 邮件 → 签名 → 新建，然后粘贴。新版 Outlook / 网页版：设置 → 邮件 → 撰写和回复 → 粘贴到签名框中。',
      apple: 'Apple Mail：邮件 → 设置 → 签名 → 添加签名，然后粘贴。取消勾选“始终使用默认邮件字体”。',
    },
  },
  businessCards: {
    title: '名片',
    emptyTitle: '创建你的数字名片',
    emptySubtitle: '添加你的联系方式，任何人都能一键保存到手机 — 然后通过二维码或 .vcf 文件分享。',
    createButton: '创建名片',
    sectionButton: '保存联系人按钮',
    sectionButtonSubtitle: '“保存联系人”按钮的外观及其在你主页上出现的位置。',
    showButton: '在我的主页显示',
    showButtonSubtitle: '在你的公开页面显示“保存联系人”按钮。',
    placement: '按钮位置',
    placementSubtitle: '选择按钮出现的位置。',
    showInHeader: '在页头显示',
    placementHeader: '主页页头',
    placementHeaderHint: '显示在你的姓名和头像下方。',
    placementContact: '联系方式区域',
    placementContactHint: '出现在你的联系方式弹窗内。',
    placementBottom: '悬浮按钮',
    placementBottomHint: '访客滚动时始终固定在页面底部。',
    none: '无',
    buttonLabel: '按钮文字',
    buttonLabelSubtitle: '按钮上显示的文字。',
    saveContact: '保存联系人',
    sectionDetails: '联系方式',
    sectionDetailsSubtitle: '这些信息将保存到名片中。',
    leadCapture: '收集联系人',
    leadCaptureSubtitle: '让收到你名片的人回传他们的信息 — 直接进入你的受众库。',
    leadCaptureToggle: '启用“分享你的信息”',
    leadCaptureToggleHint: '在你的公开名片上显示联系表单。',
    leadTag: '为新线索添加标签',
    leadTagSubtitle: '每个收集到的联系人都会打上此标签（例如活动或推广名称）。',
    leadTagPlaceholder: '例如：Conference 2026',
    delete: '删除名片',
    previewHint: '这是访客看到的名片效果。',
    share: '分享与二维码',
    shareSubtitle: '扫描二维码或分享链接以打开你的主页。',
    download: '下载 .vcf',
    copyLink: '复制链接',
    copied: '链接已复制！',
    renewLink: '更新链接',
    renewing: '更新中…',
    renewConfirm: '更新名片链接？当前的二维码和已分享的链接将失效。',
    linkRenewed: '名片链接已更新',
    scans: '{count} 次扫描',
    digitalCard: '数字名片',
    physicalCard: '实体名片',
    cardStyle: '名片样式',
    cardStyleSubtitle: '设置显示名称、选择背景色并将名片添加到钱包。',
    displayName: '显示名称',
    backgroundColour: '背景颜色',
    addAppleWallet: '添加到 Apple Wallet',
    addGoogleWallet: '添加到 Google Wallet',
    nameLabel: '名称',
    urlLabel: 'URL',
    walletScanTitle: '扫描二维码保存到钱包',
    walletScanSubtitle: '它将保存到你手机的数字钱包中。',
    walletUseLink: '或使用此链接',
    walletComingSoonTitle: '即将完成',
    walletComingSoon: '钱包卡片即将推出。',
    done: '完成',
    physicalTitle: '订购实体名片',
    physicalSubtitle: 'NFC 名片即将推出。',
  },
  shortLinks: {
    title: '短链接',
    addLink: '添加链接',
    name: '名称',
    slug: '别名',
    slugTooltip: '点击编辑按钮即可更改别名',
    destinationUrl: '目标 URL',
    metadata: '元数据',
    utmTags: 'UTM 标签',
    customizeMetadata: '自定义链接的元数据',
    metaTitle: '标题',
    metaDescription: '描述',
    favicon: '网站图标',
    imagePreview: '图片预览',
    addUtm: '为链接添加 UTM 标签（可选）',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: '在此粘贴你的长链接',
    shorten: '缩短链接',
    edit: '编辑项目详情',
  },
  audience: {
    title: '受众',
    total: '总计',
    totalMembers: '受众成员总数',
    totalContacts: '联系人总数',
    forms: '表单',
    subscribers: '订阅者',
    customers: '客户',
    noAudienceMembers: '无联系人',
    emptyAudienceMembers: '点击按钮添加新联系人',
    addAudienceMember: '添加联系人',
    noSubscribers: '无订阅者',
    emptySubscribers: '通过在 Link in Bio 中添加板块来增加订阅者',
    addDataCollect: '添加数据收集板块',
    noResponses: '无回复',
    emptyResponses: '通过在 Link in Bio 中添加板块来增加回复',
    addFormBlock: '添加表单板块',
    noCustomers: '无客户',
    emptyCustomers: '通过在 Link in Bio 中添加商品来增加客户',
    addProduct: '添加商品',
    addContactModal: {
      title: '添加新联系人',
      name: '姓名',
      nameTooltip: '输入联系人姓名',
      email: '邮箱',
      emailTooltip: '输入联系人的邮箱地址',
      phone: '电话',
      phoneTooltip: '输入联系人的电话号码',
      telegram: 'Telegram',
      telegramTooltip: '输入联系人的 Telegram 用户名或链接',
      whatsapp: 'WhatsApp',
      whatsappTooltip: '输入联系人的 WhatsApp 号码',
      instagram: 'Instagram',
      instagramTooltip: '输入联系人的 Instagram 用户名或链接',
      messenger: 'Messenger',
      messengerTooltip: '输入联系人的 Messenger 用户名或链接',
      viber: 'Viber',
      viberTooltip: '输入联系人的 Viber 号码',
      address: '地址',
      addressTooltip: '输入联系人的地址',
      add: '添加',
    },
    search: {
      search: '搜索',
      error: '搜索框中输入了无效字符',
      notFound: '未找到结果',
    },
  },
  auth: {
    logIn: '登录',
    logInWith: '使用以下方式登录',
    signIn: '登录',
    signInWith: '使用以下方式注册',
    email: '邮箱',
    password: '密码',
    notHaveAccount: '还没有账户？',
    createAccount: '创建新账户',
    createYourAccount: '创建你的账户',
    signUp: '注册',
    haveAccount: '如果你已有账户',
    or: '或',
    reset: '重置',
    resetPassword: '重置密码',
    resetTitle: '恢复链接已发送至你的邮箱',
    goToHome: '前往首页',
    byClicking: '点击',
    youAreAgree: '即表示你同意 UniLink 的',
    terms: '服务条款',
    andConfirm: '以及我们的',
    usagePolicy: '使用政策',
    signInGoogle: '使用 Google 登录',
    forgotPassword: '忘记密码？',
  },
  menu: {
    moreApps: '更多应用',
    account: '账户',
    more: '更多',
    storyWidget: '嵌入 Stories',
    integrations: '集成',
    socialAccounts: '社交账户',
    aiContent: 'AI 内容',
    aiPosts: 'AI 帖子',
    postIdeas: '帖子灵感',
    contentPlanner: '内容规划器',
    aiImages: 'AI 图片',
    adBuilder: '广告构建器',
    aiVideo: 'AI 视频',
    planner: '规划器',
    customers: '客户',
    subscribers: '订阅者',
    forms: '表单',
    allAudience: '所有受众',
    payments: '支付',
    orders: '订单',
    products: '商品',
    events: '活动',
    appointments: '预约',
    discounts: '折扣',
    affiliates: '推广联盟',
    instantPages: '即时页面',
    openInNewTab: '在新标签页打开',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: '网站',
    store: '商店',
    audience: '受众',
    emailMarketing: '邮件营销',
    postPlaner: '帖子规划器',
    posts: '帖子',
    agents: '智能助手',
    community: '社区',
    profileHealth: '主页健康度',
    socialPlanner: '社交规划器',
    shortLinks: '短链接',
    businessCards: '名片',
    emailSignatures: '邮件签名',
    virtualBackgrounds: '虚拟背景',
    adsCampaigns: '广告管理器',
    views: '浏览量',
    clicks: '点击量',
    allWebsites: '所有网站',
    createNewAccount: '创建新账户',
    createNewWebsite: '创建新主页',
    tools: '工具',
    borderGenerator: '边框生成器',
    yourPlan: '你的方案：',
    upgrade: '升级',
    accountSettings: '账户设置',
    manageWebsites: '管理主页',
    updates: '更新',
    autoUpdate: '自动更新',
    logOut: '退出登录',
    myPages: '我的页面',
    design: '设计',
    heading: '标题',
    analytics: '分析',
    settings: '设置',
    open: '打开',
    language: '语言',
    siteLanguage: '公开网站语言',
    dashboardLanguage: '仪表板语言',
    movePage: '移动页面',
    editBlock: '编辑板块',
    renameBlock: '重命名板块',
    rename: '重命名',
    deleteBlock: '删除板块',
    archiveBlock: '归档板块',
    archive: '归档',
    scheduleBlock: '排期板块',
    copyBlock: '复制板块',
    dublicateBlock: '复制板块',
    content: '内容',
    preview: '预览',
    thumbnail: '缩略图',
    copy: '复制',
    moveBlock: '移动板块',
    move: '移动',
    edit: '编辑',
    delete: '删除',
    schedule: '排期',
    dublicate: '复制',
    smartReply: 'Instagram 回复',
    marketing: '营销',
    selectBlocks: '选择板块',
    selectAll: '全选',
    cancelSelection: '取消',
    blocksSelected: '已选择',
    moveToPage: '移动到页面',
    newPage: '新建页面',
    openPage: '打开页面',
    pageSettings: '页面设置',
    deletePage: '删除页面',
    appInBio: 'App in Bio',
    blog: '博客',
    buildFromReference: '从参考图构建',
    publish: '发布',
    creatorHub: '创作者中心',
    qrCodes: '二维码',
    apps: '应用',
    automations: '自动化',
    messages: '收件箱',
    form: '嵌入表单',
    embedTools: '嵌入工具',
  },
  modal: {
    addInstagram: '添加 Instagram',
    addYourInstagram: '添加你的 Instagram 账户',
    cropYourAvatar: '裁剪你的头像',
    removeSite: '确定要删除网站吗？',
    areYouSure: '你确定要',
    areYouSureDelete: '确定要删除此板块吗？',
    areYouSureArchive: '确定要归档此板块吗？',
    areYouSurePermanentDelete: '确定要永久删除此板块吗？此操作无法撤销。',
    remove: '移除',
    site: '网站',
    removeAccountText: '移除你的账户',
    moveBlock: '将板块移动到其他页面',
    moveBlockText: '此操作会将板块移到另一个页面的底部。之后你可以在新页面上重新排列该板块',
    profileTitle: '更改头像',
    profileText: '从你的设备选择图片或 GIF。',
    profileAvatar: '个人头像',
    addProfilePicture: '添加头像',
    storiesTitle: 'Stories',
    storiesText: '分享你的日常瞬间。',
    thoughtsTitle: '想法',
    thoughtsText: '分享你的想法。',
    accountPageDescription: '这是你的账户页面，你可以在此自定义页面外观、添加各种功能板块等。',
  },
  modalSubscribe: {
    plan: '方案',
    usdMonth: '美元/月',
    sites: '网站',
    sitesMuch: '网站',
    notification: '通知',
    noNotification: '暂无通知',
    inCategory: '在',
    categoryYet: '分类下暂无项目。',
    externalPixels: '外部像素',
    parameters: '参数',
    analyticsReports: '分析与报告',
    noUniLinkLogo: '无 UniLink 标志',
    inProfile: '在主页中',
    verifiedBadge: '认证徽章',
    your: '你的',
    customDomain: '自定义域名',
    emailMarketing: '邮件营销',
    liveSupport: '在线支持',
    dataSecured: '数据按照 PCI DSS 标准进行安全保护',
    thankYou: '感谢你的关注。我们会尽快与你联系。',
    socialMediaScheduler: '社交媒体排期工具',
    featureRequest: '功能请求',
    markAllRead: '全部标为已读',
    currentPlan: '当前方案',
    features: '功能',
  },
  buttons: {
    upgrade: '升级方案',
    buyProPlan: '购买 Pro 方案',
    continue: '继续',
    skip: '跳过',
    cancel: '取消',
    confirm: '确认',
    back: '返回',
    save: '保存',
    add: '添加',
    added: '已添加',
    done: '完成',
    ok: '确定',
    edit: '编辑',
    delete: '删除',
    remove: '移除',
    setAsDefault: '设为默认',
    subscribeNow: '立即订阅',
    yes: '是',
    preview: '预览',
    generate: '生成',
    changePassword: '修改密码',
    deleteAccount: '删除账户',
    removeAccount: '移除账户',
    deleteProfile: '删除主页',
    addBlock: '添加板块',
    copyLink: '复制链接',
    active: '启用',
    update: '更新',
    updatePro: '升级方案',
    prev: '上一步',
    next: '下一步',
    uploadImage: '上传图片',
    uploadVideo: '上传视频',
    loadMore: '加载更多',
    uploadProductImage: '上传商品图片',
    claim: '领取',
    removeSite: '删除网站',
    move: '移动',
    addButton: '添加按钮',
    actionButton: '操作按钮',
    directMessage: '私信',
    subscribe: '订阅',
    button: '按钮',
    generateWithAI: '用 AI 生成',
    cta: 'CTA',
    cart: '购物车',
    direct: '私信',
    follow: '关注',
    addNewItem: '添加新项目',
  },
  support: {
    liveSupport: '在线支持',
    response: '工作时间（GMT+3 上午 8 点 - 晚上 10 点）内我们通常在 1 分钟内回复',
    founder: 'Denys Bilozor',
    ceo: 'UniLink 创始人兼 CEO',
  },
  wizard: {
    createNewProfile: '创建新主页',
    createProfile: '创建主页',
    continue: '继续',
    tellUs: '介绍一下你自己',
    addSocialLinks: '添加所有社交网络，我们会在你的资料库中展示它们',
    addMoreLinks: '添加更多链接',
    addLink: '添加链接',
    selectCategory: '选择一个最能描述你的分类：',
    chooseTemplate: '选择模板',
    skip: '跳过',
    step: '步骤',
    of: '共',
    yourName: '你的姓名',
    search: '搜索',
    blog: '博客',
    creator: '创作者',
    music: '音乐',
    events: '活动',
    esoteric: '玄学',
    fashion: '时尚',
    influencer: '网红',
    food: '美食',
    smallBusiness: '小型企业',
    marketing: '营销',
    education: '教育',
    socialMedia: '社交媒体',
    coaching: '辅导咨询',
    ecommerce: '电商',
    healthAndFitness: '健康与健身',
    beautyWellness: '美容与养生',
  },
  billing: {
    back: '返回',
    findPlan: '找到适合你的方案',
    changeAnytime: '你可以随时更改。',
    subtitle: '随时升级、降级或取消。',
    currentPlan: '当前方案',
    mostPopular: '最受欢迎',
    upgradeTo: '升级到 {plan}',
    includes: '包含：',
    everythingIn: '{plan} 的全部功能，另加：',
    secure: '支付按照 PCI DSS 标准进行安全保护。',
  },
  field: {
    fullName: '全名',
    username: '用户名',
    addValue: '添加值',
    newValue: '新值',
    placeholderDefault: '文字、数字、符号等。',
    addInstagramUsername: '添加 Instagram 用户名',
    nameDefault: 'Jhon',
    enterYourLink: '输入你的链接',
    searchImage: '搜索图片',
    pasteLink: '粘贴链接',
    pasteLinkTip: '添加指向任意网页的链接',
    searchGIFs: '搜索 GIF',
    searchIcons: '搜索图标',
    searchVideo: '搜索视频',
    search: '搜索',
    insertURL: '插入 URL',
    writeYourDescription: '填写你的描述',
    headerCTAbutton: '页头 CTA 按钮',
    enterTitle: '输入标题',
    enterDescription: '输入描述',
    enterURL: '输入规范 URL',
  },
  tooltip: {
    addImage: '添加图片',
    labelModalTitle: '标签设置',
    addLabel: '+ 添加标签',
    label: '标签',
    labelCaption: '输入标签',
    labelText: '标签文字',
    labelTextCaption: '输入标签文字',
    labelTextPlaceholder: '标签',
    labelUrl: '标签 URL',
    labelUrlCaption: '输入标签 URL',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: '无标签',
    colorFrom: '起始颜色',
    colorTo: '结束颜色',
    highlight: '高亮',
    firstName: '名字',
    firstNameCaption: '输入你的名字',
    lastName: '姓氏',
    lastNameCaption: '输入你的姓氏',
    jobTitle: '职位',
    jobTitleCaption: '输入你的职位',
    organization: '组织',
    organizationCaption: '输入你的组织',
    email: '邮箱',
    emailCaption: '输入你的邮箱',
    workPhone: '工作电话',
    workPhoneCaption: '输入你的工作电话',
    mobilePhone: '手机',
    mobilePhoneCaption: '输入你的手机号',
    website: '网站',
    websiteCaption: '输入你的网站',
    information: '信息',
    informationCaption: '输入你的信息',
    streetAddress: '街道地址',
    streetAddressCaption: '输入你的街道地址',
    city: '城市',
    cityCaption: '输入你的城市',
    state: '省/州',
    stateCaption: '输入你的省/州',
    postalCode: '邮政编码',
    postalCodeCaption: '输入你的邮政编码',
    country: '国家/地区',
    countryCaption: '输入你的国家/地区',
    titleColor: '标题颜色',
    titleColorCaption: '你可以更改标题颜色',
    fontFamily: '字体',
    fontFamilyCaption: '你可以更改字体',
    fontSize: '字号',
    fontSizeLabel: '标签字号',
    fontSizeCaption: '你可以更改字号',
    fontSelect: '字体',
    fontSelectCaption: '选择字体',
    imageMargin: '图片外边距',
    profilePicture: '头像',
    profilePictureCaption: '更改你的头像',
    pictureSize: '图片尺寸',
    pictureSizeCaption: '你可以更改图片尺寸',
    title: '标题',
    titleCaption: '输入标题',
    blockCaption: '输入你板块的标题',
    titlePageCaption: '输入你页面的标题',
    templates: '模板',
    templatesCaption: '为你的页面选择模板',
    myTemplates: '我的模板',
    myTemplatesEmpty: '暂无模板。保存当前页面设计以便日后重用。',
    saveAsTemplate: '另存为模板',
    saveCurrentAsTemplate: '将当前页保存为模板',
    templateSaved: '模板已保存',
    templateApplied: '模板已应用',
    buildFromReference: '从参考生成',
    templateAppliedCount: '模板已应用 — 添加了 {n} 个板块',
    searchTemplates: '搜索模板…',
    favorites: '收藏',
    previewLive: '实时预览',
    previewingTemplate: '正在预览',
    exitPreview: '退出',
    templateKind: '包含内容',
    publish: '发布',
    unpublish: '取消发布',
    templatePublished: '模板已发布',
    templateUnpublished: '模板已取消发布',
    discoverTemplates: '发现社区',
    discoverSubtitle: '由 UniLink 上其他创作者发布的免费模板。',
    discoverEmpty: '暂无公开模板 — 成为第一个发布的人。',
    pricing: '定价',
    background: '背景',
    backgroundColor: '背景颜色',
    textBackground: '文字背景',
    textBackgroundCaption: '选择文字背景颜色',
    textColor: '文字颜色',
    textColorCaption: '选择文字颜色',
    gradientBackground: '渐变背景',
    gradientColor: '渐变颜色',
    BackgroundType: '类型',
    backgroundSource: '背景来源',
    backgroundSourceCaption: '选择背景来源',
    backgroundStyle: '背景样式',
    backgroundStyleCaption: '选择背景样式',
    backgroundStylesNormal: '常规',
    backgroundStylesGlass: '玻璃',
    backgroundStylesOutline: '描边',
    backgroundTypeCaption: '选择背景类型',
    color: '颜色',
    colorTooltip: '你可以更改颜色',
    backgroundOpacityTooltip: '拖动滑块设置背景不透明度',
    backgroundBlur: '背景模糊',
    backgroundBlurCaption: '拖动滑块使背景模糊',
    backgroundBrightness: '背景亮度',
    backgroundBrightnessCaption: '拖动滑块更改背景亮度',
    backgroundContrast: '背景对比度',
    backgroundContrastCaption: '拖动滑块更改背景对比度',
    color1: '颜色 1',
    color2: '颜色 2',
    colorCaption: '输入你页面的颜色',
    gradient: '渐变',
    image: '图片',
    photo: '照片',
    gif: 'GIF',
    animation: '动画',
    video: '视频',
    hexColor: '十六进制颜色',
    direction: '方向',
    gradientDirection: '渐变方向',
    directionCaption: '拖动滑块设置渐变方向',
    offset: '偏移',
    gradientOffset: '渐变偏移',
    offsetCaption: '拖动滑块设置渐变偏移',
    backgroundDarkness: '背景暗度',
    backgroundDarknessCaption: '拖动滑块使背景图片变暗',
    uploadVideo: '上传视频',
    uploadFile: '上传文件',
    uploadVideoCaption: '作为页面背景的视频',
    linkToVideo: '视频链接',
    linkToVideoCaption: '添加视频链接',
    videoWithSound: '有声视频',
    videoWithSoundCaption: '播放有声视频',
    fonts: '字体',
    fontRoles: {
      heading: '标题',
      subtitle: '副标题',
      body: '全局',
    },
    fontWeight: '字重',
    fontWeightCaption: '点击选择你的字重',
    preloader: '预加载动画',
    preview: '预览',
    hideLogo: '隐藏 UniLink 标志',
    cover: '封面',
    coverCaption: '更改封面',
    coverCaptionHeader: '为页头封面添加图片或视频',
    pageNavigation: '页面导航',
    websiteNavigation: '标签导航',
    backgroundOpacity: '背景不透明度',
    backgroundOpacityCaption: '拖动滑块设置按钮背景不透明度',
    borderRadius: '圆角半径',
    borderRadiusCaption: '拖动滑块设置圆角半径',
    heightTabs: '标签高度',
    heightTabsCaption: '拖动滑块设置标签高度',
    backgroundShadow: '背景阴影',
    backgroundShape: '背景形状',
    backgroundBorder: '背景边框',
    opacity: '不透明度',
    opacityCaption: '拖动滑块设置不透明度',
    shape: '形状',
    shapeCaption: '设置形状',
    text: '文字',
    textCaption: '输入文字',
    textSize: '文字大小',
    textSizeCaption: '拖动滑块设置文字大小',
    additionalText: '附加文字',
    username: '用户名',
    currency: '货币',
    language: '语言',
    timeZone: '时区',
    websiteNiche: '网站定位',
    websiteNicheCaption: '输入你的网站定位',
    renameCaption: '重命名板块标题',
    description: '描述',
    descriptionCaption: '输入描述',
    actionButton: '操作按钮',
    actionButtonCaption: '行动号召按钮可激励访客采取行动',
    animationDirection: '动画方向',
    animationDirectionCaption: '选择动画方向',
    buttonTitle: '按钮标题',
    buttonTitleCaption: '输入按钮标题',
    buttonUrl: '按钮 URL',
    buttonUrlCaption: 'URL 将在新窗口中打开',
    imageSize: '图片尺寸',
    imageSizeCaption: '拖动滑块设置图片尺寸',
    view: '视图',
    viewCaption: '选择视图',
    margin: '外边距',
    marginCaption: '拖动滑块为项目上下添加外边距',
    separateTopBottom: '上 / 下',
    padding: '内边距',
    paddingCaption: '拖动滑块为项目上下添加内边距',
    fullWidth: '全宽',
    lineHeight: '行高',
    lineHeightCaption: '你可以更改行高',
    button: '按钮',
    titleSize: '标题大小',
    titleSizeCaption: '你可以更改标题大小',
    titleLineHeight: '标题行高',
    titleLineHeightCaption: '自定义标题行高，为文字带来更多设计方案',
    layout: '布局',
    layoutCaption: '创建你想要的页头布局',
    layoutAlign: '布局对齐',
    alignText: '文字对齐',
    align: '对齐',
    alignCaption: '选择对齐方式',
    position: '位置',
    positionCaption: '选择位置',
    width: '宽度',
    widthCaption: '选择横幅宽度',
    nameHeader: '姓名',
    nameCaption: '输入你的账户名称',
    shortBio: '简短简介',
    shortBioCaption: '输入你账户的简短简介',
    externalLink: '外部链接',
    externalLinkCaption: '输入你账户的外部链接',
    location: '位置',
    locationCaption: '输入你的位置',
    locationMap: '位置地图',
    locationMapCaption: '输入你位置的 URL',
    rightIcon: '右侧图标',
    rightIconCaption: '此图标将出现在按钮右侧',
    buttons: '按钮',
    buttonsCaption: '添加操作按钮',
    nameLogo: '名称标志',
    nameLogoCaption: '为你的名称上传标志',
    buttonText: '按钮文字',
    buttonTextCaption: '输入你的按钮名称',
    buttonColor: '按钮颜色',
    buttonColorCaption: '为按钮选择颜色',
    buttonColorCTACaption: '为 CTA 按钮选择背景颜色',
    cartColor: '购物车颜色',
    cartColorCaption: '为购物车选择背景颜色',
    ctaButton: 'CTA 按钮',
    ctaButtonCaption: '此图标将出现在按钮右侧',
    style: '样式',
    socialIconsStyleCaption: '你可以选择社交图标的样式',
    socialIconsShape: '社交图标形状',
    socialIconsShapeCaption: '你可以选择社交图标的形状',
    headerTextColorCaption: '你可以选择页头文字颜色',
    pictureShape: '图片形状',
    pictureShapeCaption: '你可以选择头像形状',
    socialLinks: '社交链接',
    socialLinksCaption: '添加社交链接按钮，一键快速连接你和你的客户',
    URL: 'URL',
    URLCaption: '输入 URL 地址',
    heading: '标题',
    headingTitle: '标题',
    headingTitleCaption: '输入标题',
    headingDescription: '标题描述',
    headingDescriptionCaption: '输入标题描述',
    headingImage: '标题图片',
    headingImageCaption: '为你的标题上传图片',
    headingPosition: '标题位置',
    headingInsideBlock: '板块内部',
    headingOutsideBlock: '板块外部',
    headingDivider: '标题分隔线',
    canonicalURL: '规范 URL',
    seo: 'SEO',
    seoCaption: '使用 SEO 元标签自定义你的商品',
    themes: '主题',
    brandColors: 'Brand Kit',
    applyBrandColors: '应用到主页',
    syncBlocks: '同步所有板块',
    brandColorsApplied: '品牌配色已应用',
    generatedPalette: '生成的调色板',
    applying: '应用中...',
    syncing: '同步中...',
    backgroundType: '背景类型',
    palettes: '调色板',
    previewTitle: '标题',
    previewTitleCaption: '输入预览标题',
    previewDescription: '描述',
    previewDescriptionCaption: '输入预览描述',
    previewButton: '按钮文字',
    previewButtonCaption: '输入预览按钮文字',
    previewLabel: '标签文字',
    previewLabelCaption: '输入预览标签文字',
    previewThumbnail: '缩略图',
    previewThumbnailCaption: '上传预览缩略图',
  },
  table: {
    clicks: '点击量',
    signups: '注册量',
    views: '曝光量',
    orderNumber: '订单号',
    amount: '金额',
    credits: '积分',
    invoice: '发票',
    email: '邮箱',
    card: '卡片',
    currency: '货币',
    name: '姓名',
    contact: '联系方式',
    optIn: '已同意',
    notes: '备注',
    address: '地址',
    date: '日期',
    action: '操作',
    custom: '自定义',
    status: '状态',
    tags: '标签',
    view: '查看',
    remove: '移除',
    sendEmail: '发送邮件',
    details: '详情',
    purchases: '购买',
    order: '订单',
    money: '金额',
    type: '类型',
    orderCode: '订单代码',
  },
  settings: {
    title: '设置',
    settings: '设置',
    accountSettings: '账户设置',
    email: '邮箱',
    subscription: '订阅',
    billingHistory: '账单历史',
    dueTo: '到期于',
    subscriptionDueTo: '订阅到期于',
    accountLabel: '账户',
    profileLabel: '主页',
    switchProfile: '切换主页',
    createNewProfile: '创建新主页',
    active: '启用',
    currentPlan: '当前方案',
    freePlanHint: '升级以解锁 Pro 功能并取消限制。',
    to: '至',
    renews: '续订',
    passwordChangeDesc: '更改你的账户密码',
    apiKeyDesc: '使用此密钥对 API 请求进行身份验证',
    apiDocumentation: 'API 文档',
    dashboardLanguageDesc: '你账户的界面语言',
    cancelSubscription: '取消订阅',
    cancelSubscriptionConfirm: '确定要取消订阅吗？',
    subscriptionCancelled: '你的订阅已取消。你的方案将在计费周期结束前保持有效。',
    subscriptionCancelError: '取消订阅失败。请联系支持团队。',
    deleteFirst: '永久删除你的',
    deleteSecond: '及其所有数据。此操作无法撤销。',
    account: {
      title: '账户',
      usernameNotAvailable: '用户名不可用',
      setupCustomDomain: '设置自定义域名',
      subtitle: '账户邮箱、账单、密码和 API 密钥',
    },
    profile: {
      title: '主页',
      usernameNotAvailable: '用户名不可用',
      setupCustomDomain: '设置自定义域名',
      subtitle: '管理用户名、语言、货币、时区',
      category: '分类',
      categoryCaption: '输入你主页的分类',
      usernameDesc: '你的公开用户名',
      currencyDesc: '用于收益与提现',
      languageDesc: '向访客显示的语言',
      timeZoneDesc: '用于排期与分析',
      categoryDesc: '最能描述你的主页',
      privateProfile: '私密主页',
      privateProfileDesc: '只有获批准的关注者才能查看你的主页',
    },
    aiassistant: {
      title: 'AI 助手',
      subtitle: '自定义你的 AI 助手，获得更好、更个性化的回复',
      titleText: '帮助 AI 了解你是谁，以获得更相关的回复',
      customAiTitle: '自定义指令',
      customAiPlaceholder: '为 AI 添加任何具体指令...',
      customAiDescription: '这些指令将应用于每次与 AI 的对话',
      nicknameTitle: 'AI 该怎么称呼你？',
      nicknamePlaceholder: '昵称',
      titleBio: '简介 / 描述',
      bioPlaceholder: '简单介绍一下你自己...',
      occupation: '你从事什么工作？',
      occupationPlaceholder: '例如：滑铁卢大学工程专业学生',
      aboutYouTitle: '关于你',
      aboutYouTooltip: '向你的 AI 助手介绍一下你自己',
      locationTitle: '位置',
      locationPlaceholder: '例如：乌克兰基辅',
      categoryTitle: '分类',
    },
    notifications: {
      title: '通知',
      subtitle: '设置有关新访客邮件和订单的通知',
      text: '连接即时通讯工具，接收有关新客户邮件和订单的通知',
      setUpWebhooks: '在 Webhooks 部分设置 Webhook',
      save: '保存',
      connect: '连接',
      disconnect: '断开连接',
      webhook: 'Webhook',
      emailSubmit: '数据收集提交',
      formSubmit: '表单提交',
      showSubmit: '商店提交',
      digitalSubmit: '数字商品提交',
      appointmentSubmit: '预约提交',
      requestSubmit: '服务提交',
      donationSubmit: '捐赠提交',
      email: '邮箱',
      settings: '设置',
      cartSubmit: '购物车提交',
      linkClick: '链接点击',
      contactClick: '联系方式点击',
      all: '全部',
      updates: '更新',
      messages: '消息',
      opportunities: '机会',
      insights: '洞察',
      activity: '动态',
      system: '系统',
      news: '资讯',
      more: '显示更多',
      less: '显示更少',
      connectedAccounts: '已连接的账户',
      addEmailAccount: '添加邮箱账户',
    },
    paymentSystem: {
      title: '支付系统',
      subtitle: '通过 Stripe 或 PayPal 设置提现',
      text: '查看手续费',
      connected: '已连接',
      active: '在网站上接受支付',
      pending: '待处理',
      disconnect: '断开连接',
      connect: '连接',
      add: '添加',
      ofYourAccount: '你账户的',
      save: '保存',
    },
    manualPayments: {
      title: '手动 / 线下支付',
      hint: '客户线下付款（银行转账、现金、二维码）。你手动确认订单。',
      save: '保存',
      iban: 'IBAN',
      accountHolder: '账户持有人姓名',
      bankName: '银行名称',
      phone: '电话',
      payeeName: '收款人姓名',
      instruction: '说明',
      instructionHint: '可使用 **粗体** ~删除线~ _斜体_ 装饰',
      requireProof: '要求付款凭证',
      requireProofHint: '要完成结账，客户必须上传截图（收据、银行转账确认或任何付款凭证）。',
      markPaidOnConfirm: '客户确认后标记为已付款',
      markPaidOnConfirmHint: '客户确认付款后，支付状态自动更新为“已付款”。',
      contactBeforePay: '启用付款前联系卖家',
      contactBeforePayHint: '让客户可以跳过付款以联系卖家，增加咨询量，同时建立信任并减少取消。',
    },
    shop: {
      title: '商店',
      subtitle: '设置分类和属性',
      label: {
        title: '标签',
        subtitle: '为商品卡片添加标签',
        addValue: '添加值',
        save: '保存',
        value: '值',
        enterTitle: '输入标题',
        maximum: '最多可添加 5 个值',
        add: '添加',
        edit: '编辑',
        labels: '标签',
      },
      category: {
        title: '分类',
        subtitle: '为你的商品添加分类',
        addCategory: '添加分类',
        save: '保存',
        maximum: '最多可添加',
        editTitle: '分类',
        name: '名称',
        namePlaceholder: '输入分类',
        visibility: '可见性',
        visible: '可见',
        hidden: '隐藏',
        description: '描述',
        descriptionHint: '描述须少于 100 个字符',
        descriptionPlaceholder: '添加简短描述',
        cover: '封面',
        view: '查看',
        share: '分享',
        linkCopied: '链接已复制',
        saveFirst: '请先保存分类',
        moveOut: '移出',
      },
      property: {
        title: '属性',
        subtitle: '为你的商品添加属性',
        addProperties: '添加属性',
        properties: '属性',
        type: '类型',
        typeTooltip: '你的属性类型',
        titleModal: '标题',
        titleModalTooltip: '你的属性名称',
        enterTitle: '输入标题',
        value: '值',
        addValue: '添加值',
        maximum: '最多可添加值的数量为',
        save: '保存',
        cancel: '取消',
        remove: '移除',
        addPropertyToItem: '为项目添加属性',
        add: '添加',
        edit: '编辑',
        propertiesSmall: '属性',
        required: '必填',
        requiredTooltip: '设置购买所需的必填属性',
        selectAll: '全选',
      },
      preorderForm: {
        title: '预订表单',
        subtitle: '设置预订表单字段',
        fields: '字段',
        fieldsTooltip: '向表单添加字段',
        required: '必填',
        submitButton: '提交按钮标题',
        redirectUrl: '跳转 URL（可选）',
        resultText: '结果文字',
        save: '保存',
        name: '姓名',
        emailAddress: '邮箱地址',
        phone: '电话',
        address: '地址',
        comment: '备注',
      },
      shipping: {
        title: '客户信息',
        subtitle: '结账时向买家收集的字段',
        fields: '字段',
        fieldsTooltip: '向结账表单添加字段',
        required: '必填',
        save: '保存',
        name: '姓名',
        emailAddress: '邮箱地址',
        phone: '电话',
        address: '地址',
        comment: '备注',
        addCustomField: '添加自定义字段',
        addFormInfo: '添加表单信息',
        editFormInfo: '编辑表单信息',
        type: '类型',
        typeTooltip: '自定义字段类型',
        fieldName: '字段名称',
        fieldNameTooltip: '自定义字段的名称',
        placeholder: '占位提示',
        placeholderTooltip: '自定义字段的占位提示',
        delete: '删除',
        update: '更新',
        add: '添加',
      },
      delivery: {
        title: '配送方式',
        subtitle: '为你的商店配置快递、本地配送和自提。',
        loading: '加载中…',
        inactive: '未启用',
        confirmDelete: '删除此配送方式？',
        category: {
          shipping: '快递',
          localDelivery: '本地配送',
          selfPickup: '自提',
        },
        rateType: {
          free: '免费',
          conditionalFree: '有条件免费',
          flatRate: '统一费率',
          customRates: '自定义费率',
          carrierApi: '承运商 API',
        },
        carrier: {
          custom: '自定义承运商',
        },
        add: {
          shipping: '添加快递',
          localDelivery: '添加本地配送',
          selfPickup: '添加自提',
        },
        actions: {
          edit: '编辑',
          delete: '删除',
          save: '保存',
          cancel: '取消',
        },
        fields: {
          name: '名称',
          namePh: '例如：标准快递',
          description: '描述',
          isActive: '启用',
          estimatedDays: '预计天数',
          currency: '货币',
          countryCodes: '国家/地区代码（CSV）',
          carrier: '承运商',
          rateType: '费率类型',
          flatPrice: '统一价格',
          freeThreshold: '满额免费（小计）',
          fallbackPrice: '兜底价格',
          customRates: '自定义费率行',
          senderCity: '发件城市名称',
          senderCityRef: '发件城市引用',
          pickupInstructions: '自提说明',
          pickupCharge: '自提费用',
          askPickupDateTime: '结账时询问自提日期/时间',
        },
        rateRow: {
          subtotal: '按小计',
          weight: '按重量（g）',
          min: '最小',
          max: '最大',
          price: '价格',
          add: '添加行',
        },
      },
      legal: {
        title: '法律文件',
        subtitle: '条款、隐私、退货政策 — 结账时向客户展示。',
        loading: '加载中…',
        empty: '暂无法律文件。',
        inactive: '未启用',
        required: '必需',
        confirmDelete: '删除此文件？',
        addNew: '+ 添加文件',
        types: {
          terms: '服务条款',
          privacy: '隐私政策',
          returns: '退货 / 退款政策',
          shipping: '配送政策',
          cookies: 'Cookie 政策',
          custom: '自定义',
        },
        fields: {
          title: '标题',
          titlePh: '例如：服务条款',
          type: '文件类型',
          content: '内容',
          contentPh: '在此撰写你的法律文本…',
          isActive: '启用',
          requireAcceptance: '结账时要求接受',
        },
        actions: {
          edit: '编辑',
          delete: '删除',
          save: '保存',
          cancel: '取消',
        },
      },
      checkoutGroup: '结账',
      serviceCharge: {
        title: '服务费',
        subtitle: '为每笔订单添加服务费或小费。',
        label: '描述',
        labelPh: '例如：5% 服务费和 $3 配送小费',
        rate: '费率',
        rateHint: '订单小计的百分比。',
        amount: '金额',
        amountHint: '额外加收的固定金额。',
      },
      tip: {
        title: '小费',
        subtitle: '让客户在结账时为订单添加小费。',
        enable: '启用小费',
        presets: '小费预设（%）',
        noPresets: '暂无预设 — 在下方添加一个。',
        presetPh: '例如：10',
        addPreset: '+ 添加预设',
        presetsHint: '在结账时显示为快速选择按钮。最多 6 个。',
        remove: '移除',
        allowCustom: '允许自定义金额',
        label: '提示文字',
        labelPh: '例如：为优质服务添加小费',
        save: '保存',
        saving: '保存中…',
      },
      orderNumber: {
        title: '订单号',
        subtitle: '自定义订单号的样式。',
        next: '下一个订单号',
        prefix: '前缀',
        suffix: '后缀',
        showInMessage: '在发票和订单消息中显示',
        reset: '重置订单号',
      },
      orderMessage: {
        title: '订单消息',
        subtitle: '自定义发送给客户的订单确认消息。',
        footer: '消息页脚',
        footerPh: '例如：感谢下单！关注我们 @yourbrand',
        footerHint: '附加到每条订单确认消息末尾。',
        plain: '纯文本消息',
        plainHint: '移除订单消息中的所有格式。',
      },
      invoice: {
        title: '发票',
        subtitle: '附加到已付款订单的品牌发票。',
        upgrade: '升级',
        showLogo: '显示标志',
        header: '页眉',
        footer: '页脚',
        companyName: '公司名称',
        companyEmail: '公司邮箱',
        companyPhone: '公司电话',
        companyAddress: '公司地址',
        companyAddressPh: '输入地址',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: '使用 SEO 元标签自定义你的页面',
      titleText: '标题',
      titlePlaceholder: '输入页面标题',
      description: '描述',
      descriptionPlaceholder: '输入页面描述',
      favicon: '网站图标',
      uploadFavicon: '上传网站图标',
      imagePreview: '图片预览',
      useCustom: '使用自定义图片',
      save: '保存',
      visualise: '可视化你的网站预览在 Google 中的样子',
      inMessengers: '在即时通讯中',
      inSocial: '在社交媒体中',
      searchEngine: '搜索引擎',
      googleIndexable: '允许 Google 收录',
      sitemap: {
        title: '站点地图',
        entryHint: '管理搜索引擎可收录哪些页面和商品。',
        setupLink: '自定义',
        mainEntry: '收录网站',
        subtitle: '选择搜索引擎应收录哪些页面。禁用的页面会带上 noindex 标签并从站点地图中移除。',
        mainPage: '主页面',
        pagesSection: '页面',
        pagesHint: '为你网站的每个附加页面开关收录。',
        noPages: '暂无附加页面。',
        productsSection: '商品',
        productsHint: '为各个商品页面开关收录。',
        noProducts: '暂无商品。',
        postsSection: '帖子',
        postsHint: '为各个帖子开关收录。',
        noPosts: '暂无帖子。',
        blogSection: '博客文章',
        blogHint: '为各篇博客文章开关收录。',
        noArticles: '暂无博客文章。',
        loadMore: '加载更多',
        loading: '加载中…',
      },
    },
    analytics: {
      title: '分析',
      subtitle: '集成 Facebook Pixel、Google Analytics 和 UTM 参数',
      facebookTooltip: '连接 Facebook 以显示分析数据',
      googleAnalyticsTooltip: 'Google Analytics 让你衡量广告投资回报率并跟踪所有链接。',
      googleTagManagerTooltip: 'Google 跟踪代码管理器让你在网站上配置并即时部署代码',
      tikTokPixelTooltip: 'TikTok Pixel 是一款强大的衡量工具，可跟踪你的 TikTok 广告对网站的影响',
      pinterestTag: 'Pinterest 代码',
      pinterestTagTooltip: 'Pinterest 代码是一段添加到网站的代码，可让 Pinterest 跟踪访客以及他们在看到你的 Pinterest 广告后在网站上的操作。',
      tag: '代码',
      headerTagTooltip: '粘贴出现在网站 head 中的代码',
      bodyTagTooltip: '粘贴出现在网站 body 中的代码',
      utmParameters: 'UTM 参数',
      utmParametersTooltip: '使用自定义 URL 收集广告系列数据。为 URL 添加参数以识别带来流量的广告系列。',
      makeAnalytics: '让 Google Analytics 将 UniLink 流量显示为社交流量',
      the: '该',
      campaign: 'campaign',
      parameter: '参数会根据每个帖子或链接的标题动态设置',
      save: '保存',
    },
    customDomain: {
      title: '自定义域名',
      subtitle: '使用自定义域名自定义你的页面',
      titleTooltip: '添加自定义域名',
      save: '保存',
      connect: '连接',
      connecting: '连接中',
      instructions: '说明',
      submit: '提交',
      submitting: '提交中...',
      enterDomain: '输入你的域名',
      domainPlaceholder: 'your-domain.com',
      steps: {
        submitting: '正在提交请求',
        validation: '域名验证',
        certificate: '证书签发',
        complete: '完成',
      },
      txtRecord: {
        title: 'TXT 记录',
        description: '将以下 TXT 记录添加到你的 DNS 设置中：',
        verifyButton: '验证 TXT 记录',
        verifying: '验证中...',
        verified: 'TXT 记录已验证',
      },
      cnameRecord: {
        title: 'CNAME 记录',
        description: '将以下 CNAME 记录添加到你的 DNS 设置中：',
        verifyButton: '验证 CNAME 记录',
        verifying: '验证中...',
        verified: 'CNAME 记录已验证',
      },
      dnsTable: {
        type: '类型',
        host: '主机',
        value: '值',
        ttl: 'TTL',
        copy: '复制',
        copied: '已复制！',
      },
      provisioning: {
        title: '正在签发 SSL 证书...',
        description: '这可能需要几分钟。请稍候。',
        timeout: '证书签发时间超出预期。请稍后再查看。',
      },
      complete: {
        title: '已成功为你的域名启用 HTTPS。',
        connected: '已连接',
      },
      failed: {
        title: '域名连接失败',
        tryAgain: '重试',
      },
      rootDomainWarning: '根域名要求你的 DNS 服务商支持 CNAME 展平（例如 Cloudflare、Route53）。',
      deleteConfirm: {
        title: '断开域名连接',
        message: '确定要断开此域名的连接吗？你的网站将无法再通过此域名访问。',
        confirm: '断开连接',
        cancel: '取消',
      },
    },
    developerApi: {
      title: '开发者 API',
      subtitle: '创建 API 密钥，通过 /api/v2 端点访问你的订单、商品和客户。',
      keyName: '密钥名称',
      keyNamePh: '例如：仓库同步',
      scopes: '权限',
      scopeLabels: {
        'orders:read': '读取订单',
        'products:read': '读取商品',
        'products:write': '更新商品库存',
        'customers:read': '读取客户',
      },
      create: '创建密钥',
      creating: '创建中…',
      created: 'API 密钥已创建',
      copyWarning: '请立即复制此密钥 — 它不会再次显示。',
      done: '完成',
      revoke: '撤销',
      revoked: '已撤销',
      confirmRevoke: '撤销此 API 密钥？使用它的应用将停止工作。',
      empty: '暂无 API 密钥。',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: '连接你的 WhatsApp Business 号码，以接收并回复客户消息。',
      phoneNumberId: '电话号码 ID',
      accessToken: '访问令牌',
      displayPhone: '显示电话（可选）',
      connect: '连接',
      connecting: '连接中…',
      connected: '已连接',
      disconnect: '断开连接',
      confirmDisconnect: '断开 WhatsApp 连接？',
      webhookHelp: '在你的 Meta App → WhatsApp → Configuration 中设置此回调 URL 和验证令牌：',
      webhookUrl: '回调 URL',
      verifyToken: '验证令牌',
      inbox: '收件箱',
      noMessages: '暂无消息。',
      selectThread: '选择一个会话。',
      replyPlaceholder: '输入消息…',
      send: '发送',
      broadcast: {
        title: '群发',
        audienceInbox: '收件箱联系人',
        audienceCrm: 'CRM 受众（模板）',
        message: '消息',
        inboxHint: '自由文本 — 仅在 24 小时客服窗口内的联系人才会收到。',
        templateName: '模板名称',
        templateLang: '模板语言',
        crmHint: '使用已批准的 WhatsApp 模板 — 触达 24 小时窗口外的联系人时必需。',
        send: '发送群发',
        sending: '发送中…',
        empty: '暂无群发。',
        sent: '已发送',
        failed: '失败',
      },
      autoReply: {
        title: '自动回复',
        type: '类型',
        typeKeyword: '关键词',
        typeGreeting: '问候语（首条消息）',
        typeAway: '离开（非营业时间）',
        keyword: '关键词',
        from: '起始时间',
        to: '结束时间',
        reply: '回复文字',
        add: '添加规则',
        empty: '暂无自动回复规则。',
        delete: '删除',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: '向外部服务发送实时事件通知',
      webhook: 'Webhook',
      webhookTooltip: '添加 Webhook',
      send: '将事件发送到第三方网站',
      webhookUrl: 'Webhook URL（POST 请求）',
      error: '请输入正确的链接',
      save: '保存更改',
      enableWebhooks: '启用 Webhooks',
      enableDescription: '在选定事件上发送 POST 请求',
      endpointUrl: '端点 URL',
      endpointTooltip: '在选定事件发生时接收 POST 请求的 URL',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: '事件',
      selectAll: '全选',
      deselectAll: '取消全选',
      filterPlaceholder: '筛选事件...',
      all: '全部',
      none: '无',
      active: '启用',
      inactive: '未启用',
      categories: {
        submissions: '提交',
        engagement: '互动',
      },
      eventLabels: {
        SubmitHeaderSubscribe: '页头订阅',
        SubmitHeaderMessage: '页头消息',
        SubmitDataCollect: '数据收集',
        SubmitForm: '表单提交',
        SubmitShop: '商店订单',
        SubmitShopPreorder: '商店预订',
        SubmitDigital: '数字商品',
        SubmitAppointment: '预约',
        SubmitService: '服务订单',
        SubmitEvent: '活动报名',
        SubmitCourse: '课程报名',
        SubmitDonation: '捐赠',
        SubmitMembership: '会员',
        SubmitBlog: '博客购买',
        SubmitCoupon: '优惠券已使用',
        SubmitTip: '小费',
        SubmitLink: '链接购买',
        SubmitProductMessage: '商品咨询',
        SubmitPodcast: '播客购买',
        SubmitBooking: '预订',
        SubmitRental: '租赁',
        SubmitSingleProduct: '单个商品',
        SubmitDiscount: '折扣订单',
        SubmitListing: '上架请求',
        SubmitUnlock: '内容解锁',
        SubmitChatAi: 'AI 聊天消息',
        ClickLink: '链接点击',
        ClickContact: '联系方式点击',
        AddToCart: '加入购物车',
        AddToCartSingleProduct: '单个商品加入购物车',
        AddToWishlist: '加入心愿单',
        InitiateCheckout: '发起结账',
        DownloadFile: '文件下载',
        DownloadMusic: '音乐下载',
        CopyCoupon: '复制优惠券',
        CopyDiscount: '复制折扣',
        QR_ScanQrCode: '二维码扫描',
        VisitPage: '页面访问',
      },
    },
    sensitive: {
      title: '敏感内容',
      subtitle: '在显示你的网站前显示敏感内容警告',
    },
    socialIntegration: {
      title: '社交集成',
      subtitle: '管理你的 Instagram、TikTok 集成',
      connectInstagram: '连接 Instagram',
    },
    emailIntegration: {
      title: '受众集成',
      subtitle: '将访客邮箱地址传递给 MailChimp、Reply',
      emailCaption: '添加集成以将关注者邮箱地址传递给 MailChimp',
      mailChimp: 'MailChimp 集成',
      selzy: 'Selzy 集成',
      selzyCaption: '添加 API 密钥以将关注者邮箱地址传递给 Selzy',
      sendPulse: 'SendPulse 集成',
      sendPulseCaption: '添加 API 密钥以将关注者邮箱地址传递给 SendPulse',
      reply: 'Reply 集成',
      replyCaption: '添加 API 密钥以将关注者邮箱地址传递给',
      integrations: '集成',
    },
    calendarIntegration: {
      title: '日历集成',
      subtitle: '连接你的日历服务',
      calendly: 'Calendly',
      calendlyDescription: '连接 Calendly 以同步你的活动类型和可用时间',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: '连接 Google Calendar 以同步活动并创建 Google Meet 链接',
      zoom: 'Zoom',
      zoomDescription: '连接 Zoom 以自动创建会议链接',
      googleMeet: 'Google Meet',
      googleMeetDescription: '自动创建 Google Meet 链接（需要 Google Calendar）',
    },
    storage: {
      title: '存储',
      subtitle: '将访客订单保存到 Google 表格',
      storageCaption: '添加集成以将所有客户订单保存到 Google 表格',
      emailSignup: '邮箱注册',
      emailSignupsCaption: '选择用于保存邮箱注册的表格',
      formSignups: '表单注册',
      forSignupsCaption: '选择用于保存表单注册的表格',
      shopOrders: '商店订单',
      shopOrderCaption: '选择用于保存商店订单的表格',
      disconnect: '断开表格连接',
      storageUsage: '存储使用量',
      of: '共',
      uses: '此应用使用了',
      space: '的免费磁盘空间',
      view: '查看详情',
      noItems: '暂无项目',
      files: '文件',
      images: '图片',
      videos: '视频',
      audio: '音频',
      settings: '设置',
      free: '可用',
      needMoreSpace: '需要更多空间？',
      unlockStorage: '解锁无限存储、4K 视频',
      upgradePlan: '升级方案',
      addFile: '添加文件',
      uploading: '上传中...',
      dragDrop: '或拖放到此处',
      noFilesYet: '暂无文件',
      noImagesYet: '暂无图片',
      noVideosYet: '暂无视频',
      noAudioYet: '暂无音频',
      filesHint: '上传 PDF、文档和其他下载内容，以便附加到你的 Bio 页面链接。',
      imagesHint: '上传图片以在你的 Bio 页面各处使用。',
      videosHint: '上传视频以嵌入你的 Bio 页面。',
      audioHint: '上传音频以在你的 Bio 页面分享。',
    },
  },
  productStore: {
    title: '在你的 Link-in-Bio 上显示商店标签',
    subtitle: '你的商店当前处于隐藏状态。',
  },
  sections: {
    splashScreen: {
      title: '启动屏',
      subtitle: '页面加载时显示',
    },
    promo: {
      title: '促销栏',
      subtitle: '用于展示促销信息的醒目栏',
      masterPromoMessage: '主促销栏当前已启用。如需为此页面创建自定义促销栏，你需要先禁用主促销栏。',
      titlePlaceholder: '欢迎来到我的网站！',
      switcherIsMasterPromobar: '在所有页面显示',
    },
    contact: {
      title: '联系方式',
      subtitle: '提供与你联系的方式',
      caption: '添加即时通讯按钮，一键快速连接你和你的客户',
      tooltip: '联系方式让用户可以直接与你沟通。添加你的电话、邮箱、即时通讯或位置',
      addNewContact: '添加新联系方式',
      addContact: '添加联系方式',
      chooseContact: '选择联系方式',
      enterLink: '输入你的联系方式链接',
      showDetails: '显示详情',
      enterAnyContact: '请输入任意联系方式',
      enterAnyContactCaption: '（WhatsApp、Telegram、Viber、Messenger）',
    },
    membership: {
      title: '会员',
      subtitle: '创建免费或付费的内容订阅',
      addNewTier: '添加新等级',
      editTier: '编辑等级',
      name: '名称',
      nameCaption: '输入你的等级名称',
      price: '每月价格',
      priceCaption: '输入你的等级价格',
      month: '月',
      image: '图片',
      imageCaption: '为你的等级上传图片',
    },
    pricing: {
      title: '定价',
      subtitle: '创建带价格的菜单',
      add: '添加新项目',
      edit: '编辑项目',
      name: '名称',
      nameCaption: '输入你的项目名称',
      duration: '属性',
      durationCaption: '输入你项目的时间、数量或时长',
      category: '分类',
      categoryCaption: '输入你的项目分类',
      price: '价格',
      priceCaption: '输入你的项目价格',
      month: '月',
      image: '图片',
      imageCaption: '为你的项目上传图片',
    },
    subscribe: {
      dataCollectTitle: '数据收集',
      title: '订阅',
      subtitle: '收集访客的邮箱或电话号码',
      instructionsMessage: '在你的页面添加邮箱注册字段，让访客可以轻松注册！',
      instructionsLink: '将邮箱传递给 MailChimp 以开展营销活动。',
      sectionHeaderCaption: '订阅我们的通讯',
      collecting: '收集',
      collectingCaption: '选择你的输入类型',
      addDataToCollect: '添加要收集的数据',
      email: '邮箱',
      enterEmail: '输入邮箱',
      thanksForEmail: '感谢你的邮箱',
      phone: '电话',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: '添加更新的链接',
      placeholder: '占位提示',
      placeholderCaption: '输入占位提示文字',
      button: '按钮',
      buttonCaption: '激励访客输入邮箱的文字（9 折优惠、立即订阅、下载文件等）',
      submitButton: '提交按钮',
      enterButton: '输入按钮',
      thanksMessage: '感谢消息',
      thanksMessageCaption: '订阅者的感谢消息',
      resultAction: '操作（提交后）',
      resultActionCaption: '填写表单后的操作',
      sendAnEmail: '发送邮件',
      downloadFile: '下载文件',
      redirect: '跳转',
      messageBody: '消息正文',
      messageBodyCaption: '此数据将作为回馈发送到用户邮箱（优惠券、文件下载链接等）',
      integration: '集成',
      integrationCaption: '将访客邮箱地址传递给 MailChimp、Reply',
      storage: '存储',
      storageCaption: '将访客订单保存到 Google 表格',
      maxSize: '最多可添加 3 个渠道',
    },
    text: {
      title: '文本',
      subtitle: '撰写任何关于你自己/公司的内容',
      trimBio: '截断文本',
    },
    header: {
      title: '页头',
      subtitle: '页面上放大的特色图片或视频',
      verifiedBadge: '认证徽章',
      showProfilePic: '显示头像',
      profilePicRatio: '比例',
      profilePicRatioSquare: '方形',
      profilePicRatioLandscape: '横向',
      profilePicRatioPortrait: '纵向',
      verticalCropStep: '纵向照片',
      squareCropStep: '方形头像',
      namePlaceholder: '你的姓名',
      shortBioPlaceholder: '我的简短信息',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: '城市',
      addSocial: '+ 添加社交',
      addCover: '+ 添加封面',
      addButton: '+ 添加按钮',
      topButtons: '顶部按钮',
      bottomButtons: '底部按钮',
      buttonSubtitleLanguage: '语言切换',
      buttonSubtitleContact: '通话 / 消息',
      buttonSubtitleCart: '购物车',
      buttonSubtitleCta: '行动号召',
      buttonSubtitleMessage: '消息',
      buttonSubtitleSubscribe: '订阅',
      buttonSubtitleQrcode: '二维码',
      buttonSubtitleSearch: '商品搜索',
      buttonDisabledHint: '隐藏 · 已禁用',
      addText: '+ 添加文字',
      addLabel: '+ 添加标签',
      subtitleName: '自定义你的姓名外观',
      subtitleShortBio: '自定义你的简短简介外观',
      shortBioSize: '简短简介大小',
      subtitleShortBioSize: '你可以更改简短简介的大小',
      subtitleLocation: '设置城市/国家，将访客导航到特定地点',
      headerCoverWarningMessage: '你的浏览器不支持 video 标签。',
      headerCoverTitle: '在页头上方设置封面',
      coverHeight: '封面高度',
      subtitleCoverHeight: '你可以更改封面高度',
      coverDarkness: '封面暗度',
      subtitleCoverDarkness: '拖动滑块使封面图片变暗',
      nameSize: '姓名大小',
      subtitleNameSize: '你可以更改姓名大小',
      positionText: '姓名位置',
      subtitlePositionName: '拖动滑块设置姓名位置',
      positionContent: '内容位置',
      subtitlePositionContent: '设置简介、链接、位置的位置',
      coverText: '封面上的文字',
      subtitleCoverText: '为你的封面添加文字',
      position: '位置',
      subtitlePosition: '拖动滑块设置按钮位置',
      buttonCover: '封面上的按钮',
      subtitleButtonCover: '通过选择操作为你的封面添加按钮',
      subtitleFollow: '关注按钮让用户可以关注你的动态',
      buttonOpacity: '拖动滑块更改按钮不透明度',
      subtitleCart: '购物车图标带来购物体验',
      subtitleDirect: '快捷按钮将访客导航到即时通讯',
      subtitleCTAButton: '（行动号召）激励用户点击的按钮',
      subtitleSocialLinks: '为你的社交网络打造视觉效果',
      chooseSocialLink: '选择社交链接',
      alignSocialLink: '社交链接对齐',
      enterYourSocialLink: '输入你的社交链接',
      blockShadow: '板块阴影',
      activeButtonPosition: '选中按钮位置',
      gradientColor: '渐变颜色',
      bottomGradient: '底部渐变',
      autoGradient: '自动',
      customGradient: '自定义',
      transparentGradient: '透明',
      gradientPositionLabel: '阴影位置',
      gradientPositionPhoto: '照片下方',
      gradientPositionHeader: '页头较低处',
      uploadLogo: '上传 Logo',
      customBackground: '自定义背景',
      headingLabel: '标题标签',
      customizeLabel: '自定义你的标题标签外观',
      labelText: '标签文字',
      enterLabelText: '输入标题标签的文字',
      bottomBadge: '底部色调',
      addTint: '添加色调',
      bottomBadgeText: '文字（可选）',
      bottomBadgePreset: '预设',
      bottomBadgeShape: '形状',
      bottomBadgeSize: '高度',
      bottomBadgeAction: '操作',
      bottomBadgeBgColor: '背景颜色',
      bottomBadgeTextColor: '文字颜色',
      bottomBadgeGradientFrom: '渐变起始色',
      bottomBadgeGradientTo: '渐变结束色',
      bottomBadgeGradientAngle: '渐变角度',
    },
  },
  billingHistory: {
    title: '账单历史',
    invoices: '发票',
    messageText: '你还没有支付记录。',
  },
  migrate: {
    title: '有 LinkTree 或 Taplink 吗？',
    text: '粘贴链接，一键迁移到 UniLink！',
    button: '迁移',
  },
  pages: {
    title: '页面',
    addPage: '添加页面',
    addNewPage: '添加新页面',
    deleteTitle: '确定要删除此页面吗？',
    managePage: '管理标签',
    empty: '此页面还没有任何板块。',
    dragAndDrop: '拖放其他标签以重新排序',
    pageNavigation: '页面导航设置',
    goToDesign: '前往设计设置',
    viewArchive: '查看归档',
    archivedBlocks: '已归档板块',
    noArchivedBlocks: '通过归档暂时不用的板块，让页面保持整洁、聚焦。',
    archiveAllUnpublished: '归档所有未发布板块',
    restore: '恢复',
    permanentDelete: '永久删除',
  },
  analytics: {
    lifeTimeAnalytics: '全期分析',
    impressions: '曝光量',
    impressionsText: '所选时间段内曝光量的表现统计',
    clicks: '点击量',
    clicksText: '所选时间段内“点击”事件的表现',
    signUps: '注册量',
    signUpsText: '所选时间段内“关闭”事件的表现',
    totalInteractions: '总互动数',
    totalInteractionsText: '所选时间段内的总点击量和表单注册量',
    engagementRate: '互动率',
    engagementRateText: '带来互动的主页浏览量占比',
    visitor: '访客来源',
    country: '国家/地区',
    countries: '国家/地区',
    linkClicks: '链接点击',
    content: '内容',
    views: '浏览量',
    links: '链接',
    products: '商品',
    blocks: '板块',
    pages: '页面',
    clicksLower: '次点击',
    of: '共',
    noContentData: '所选时间段暂无数据',
  },
  aiInsights: {
    title: 'AI 洞察',
    generate: '分析我的主页',
    description: '获取 AI 驱动的建议，提升你的主页表现。',
    analyzing: '正在分析你的主页...',
    refresh: '刷新',
    action: '操作',
  },
  post: {
    subscriptionTypePlaceholder: `适用于 'type' 及以上订阅`,
    postButtonText: '发布',
    newPostPlaceholder: '你在想什么',
    free: '免费',
    pro: 'Pro',
    premium: 'Premium',
    noPost: '你还没有帖子',
    editPost: '编辑帖子',
  },
  preview: {
    buy: '购买',
    connect: '连接',
  },
  activeButton: {
    initialText: '网站',
    inputPlaceholder: '搜索操作...',
    existing: '现有',
    redirect: '跳转',
    scroll: '滚动',
    title: '操作按钮',
    modalTitle: '操作按钮的动作',
    subtitle: '激励用户采取行动的按钮',
    next: '下一步',
    save: '保存',
    opensALinkFromLinksBlock: '打开 Links 板块中的链接',
    url: 'URL',
    opensAWebsite: '打开一个网站',
    openInApp: '在 App 中打开',
    addAction: '添加操作',
    actionTitle: '操作',
    actionCaption: '编辑操作类型',
    chooseOption: '选择一个选项',
    tellPeople: '告诉大家如何使用操作按钮',
    urlRedirect: 'URL 跳转',
    customUrl: '自定义 URL',
    customUrlText: '打开一个网站',
    links: '链接',
    linksText: '打开 Links 板块中的链接',
    downloadDocument: '下载文档',
    sendEmail: '发送邮件',
    opensEmailClient: '打开邮件客户端',
    phoneCall: '拨打电话',
    initiatesPhoneCall: '发起电话呼叫',
    navigation: '导航',
    openPage: '打开页面',
    opensInternalPage: '打开内部页面',
    openPageText: '打开内部页面',
    openProduct: '打开商品',
    openProductText: '从商店打开商品页面',
    openBlog: '打开博客',
    opensBlogPageFromStore: '从商店打开博客页面',
    openBlock: '打开板块',
    opensContentBlock: '打开内容板块',
    openItem: '打开项目',
    opensItemPageFromStore: '从商店打开项目页面',
    showNewModal: '显示新弹窗',
    displayContentInModalWindow: '在弹窗中显示内容',
    showProduct: '显示商品',
    displayProductInModalWindow: '在弹窗中显示商品',
    showBlog: '显示博客',
    scrollToBlock: '滚动到板块',
    scrollToBlockText: '滚动到指定的页面板块',
    scrollToItem: '滚动到项目',
    action: '操作',
    showBlock: '显示板块',
    showBlockText: '来自商店的内容板块',
    showItem: '显示项目',
    showItemText: '从商店打开项目页面',
    linksCaption: '链接',
    linksTooltip: '从 Links 板块中选择一个链接',
    pagesCaption: '页面',
    pagesTooltip: '从页面中选择一个页面',
    productsCaption: '商品',
    productsTooltip: '从列表中选择一个商品',
    blocksCaption: '板块',
    blocksTooltip: '从列表中选择一个板块',
    itemsCaption: '项目',
    itemsTooltip: '从列表中选择一个项目',
    showProductText: '在页面弹窗中显示该商品',
    more: '显示更多',
    less: '显示更少',
    showNewModalTitle: '新弹窗数据',
    uploadDocumentTitle: '点击上传或拖放',
    uploadProgressTitle: '上传中...',
    haveNoModal: '你还没有弹窗',
    haveModal: '你已选择弹窗',
    openNewModalHandler: '创建新弹窗',
    linkGroupSubTitle: '选择一个板块',
    linkItemSubTitle: '选择一个链接',
    urlItemSubTitle: '网站 URL',
    openInAppItemSubTitle: 'App URL',
    sendEmailItemSubTitle: '邮箱地址',
    phoneCallItemSubTitle: '电话号码',
    openPageGroupSubTitle: '选择页面',
    openPageItemSubTitle: '选择页面',
    openProductGroupSubTitle: '选择商品类型',
    openProductItemSubTitle: '选择商品',
    openBlogGroupSubTitle: '选择博客频道',
    openBlogItemSubTitle: '选择博客文章',
    openBlockGroupSubTitle: '选择页面',
    openBlockItemSubTitle: '选择板块',
    openItemGroupSubTitle: '选择板块',
    openItemItemSubTitle: '选择项目',
    showProductGroupSubTitle: '选择商品类型',
    showProductItemSubTitle: '选择商品',
    showBlogGroupSubTitle: '选择博客频道',
    showBlogItemSubTitle: '选择博客文章',
    showBlockGroupSubTitle: '选择页面',
    showBlockItemSubTitle: '选择板块',
    showItemGroupSubTitle: '选择板块',
    showItemItemSubTitle: '选择项目',
    scrollToBlockGroupSubTitle: '选择页面',
    scrollToBlockItemSubTitle: '选择板块',
    scrollToItemGroupSubTitle: '选择板块',
    scrollToItemItemSubTitle: '选择项目',
    linkGroupPlaceholder: '选择一个板块...',
    linkItemPlaceholder: '选择一个链接...',
    openPageItemPlaceholder: '选择一个页面...',
    openProductGroupPlaceholder: '选择一个商品类型...',
    openProductItemPlaceholder: '选择一个商品...',
    showProductGroupPlaceholder: '选择一个商品分组...',
    showProductItemPlaceholder: '选择一个商品...',
    openBlogGroupPlaceholder: '选择一个博客频道...',
    openBlogItemPlaceholder: '选择一篇博客文章...',
    openBlockGroupPlaceholder: '选择一个页面...',
    openBlockItemPlaceholder: '选择一个板块...',
    openItemGroupPlaceholder: '选择页面和板块...',
    openItemItemPlaceholder: '选择一个项目...',
    showBlogGroupPlaceholder: '选择一个博客分组...',
    showBlogItemPlaceholder: '选择一篇博客帖子...',
    showBlockGroupPlaceholder: '选择一个页面...',
    showBlockItemPlaceholder: '选择一个板块...',
    showItemGroupPlaceholder: '选择页面和板块...',
    showItemItemPlaceholder: '选择一个项目...',
    scrollToBlockGroupPlaceholder: '选择一个页面...',
    scrollToBlockItemPlaceholder: '选择一个板块...',
    scrollToItemGroupPlaceholder: '选择页面和板块...',
    scrollToItemItemPlaceholder: '选择一个项目...',
    linkReadable: '链接',
    urlReadable: 'URL',
    openInAppReadable: '在 App 中打开',
    downloadDocumentReadable: '下载文档',
    sendEmailReadable: '发送邮件',
    phoneCallReadable: '拨打电话',
    openPageReadable: '打开页面',
    openProductReadable: '打开商品',
    showNewModalReadable: '显示新弹窗',
    showProductReadable: '显示商品',
    openBlogReadable: '打开博客',
    openBlockReadable: '打开板块',
    openItemReadable: '打开项目',
    showBlogReadable: '显示博客',
    showBlockReadable: '显示板块',
    showItemReadable: '显示项目',
    scrollToBlockReadable: '滚动到板块',
    scrollToItemReadable: '滚动到项目',
  },
  design: {
    tabs: '标签',
    imageView: '图片视图',
    preview: '预览',
    buttonOpacity: '按钮不透明度',
    buttonBorder: '按钮边框',
    buttonShadow: '按钮阴影',
    itemView: '项目视图',
    itemViewTooltip: '选择项目视图',
    itemLayout: '项目布局',
    itemLayoutTooltip: '选择项目布局',
    top: '顶部',
    center: '居中',
    bottom: '底部',
    bottomLeft: '左下',
    bottomHorizontal: '底部横向',
    under: '下方',
    title: '标题',
    titleButton: '标题和按钮',
    displayOptions: '显示选项',
    displayOptionsTooltip: '选择显示选项',
    landscape: '横向',
    square: '方形',
    portrait: '纵向',
    desktopMode: '桌面模式',
    mobile: '紧凑',
    desktop: '宽屏',
    responsive: '自适应',
    custom: '自定义',
    templates: '模板',
    chooseTemplates: '选择你的模板',
    viewAll: '查看全部',
    previousTheme: '请注意，之前的主题将被永久清除。',
    useThisTemplate: '使用此模板',
    notSupportedVideo: '你的浏览器不支持 video 标签。',
    photosBy: '照片来自',
    animationBy: '动画来自',
    searchTheSame: '再次搜索相同词条以获得不同结果。',
    addImage: '添加图片',
    addVideo: '添加视频',
    orSelectFrom: '或从中选择',
    noImagesYet: '暂无图片',
    noVideosYet: '暂无视频',
    videoBy: '视频来自',
    hamburgerMenu: '汉堡菜单',
    tabsOnTop: '标签在顶部',
    tabsOnBottom: '标签在底部',
    borderType: '边框类型',
    subTitle: '选择形状、边框类型、阴影等。',
    icon: '图标',
    iconTooltip: '为你的按钮选择合适的图标',
    background: '背景',
    color: '颜色',
    backgroundOpacity: '背景不透明度',
    backgroundOpacityTooltip: '拖动滑块设置背景不透明度',
    gradient: '渐变',
    color1: '颜色 1',
    color2: '颜色 2',
    direction: '方向',
    directionTooltip: '拖动滑块设置渐变方向',
    offset: '偏移',
    offsetTooltip: '拖动滑块设置渐变偏移',
    minHeight: '最小高度',
    minHeightTooltip: '拖动滑块更改按钮的最小高度',
    align: '对齐',
    alignTooltip: '更改按钮位置',
    insert: '插入 URL',
    upload: '上传视频',
    search: '搜索视频',
    layout: '布局',
    layoutTooltip: '选择你想要的布局',
    view: '视图',
    viewTooltip: '选择你想要的视图',
    media: '媒体',
    mediaTooltip: '选择你想要的媒体',
    none: '无',
    small: '小',
    medium: '中',
    large: '大',
    round: '圆形',
    feed: '信息流',
    slider: '滑块',
    text: '文本',
    colorTooltip: '选择颜色',
    button: '按钮',
    buttonTooltip: '选择按钮颜色',
    chooseEmoji: '选择表情',
    changeEmoji: '更改你的表情',
    quantum: '量子',
    emoji: '表情',
    warp: '扭曲',
  },
  components: {
    quickAdd: {
      addLink: '添加链接',
      addVideo: '添加视频',
      addProduct: '添加商品',
      addPost: '添加帖子',
      addArticle: '添加文章',
      addPhoto: '添加照片',
      addMusic: '添加音乐',
      addFiles: '添加文件',
      addStory: '添加 Story',
    },
    emoji: {
      search: '搜索',
      clear: '清除',
      notfound: '未找到表情',
      skintext: '选择你的默认肤色',
      categories: {
        search: '搜索结果',
        recent: '常用',
        smileys: '笑脸与情感',
        people: '人物与身体',
        nature: '动物与自然',
        foods: '食物与饮品',
        activity: '活动',
        places: '旅行与地点',
        objects: '物品',
        symbols: '符号',
        flags: '旗帜',
        custom: '自定义',
      },
      categorieslabel: '表情分类',
      skintones: {
        1: '默认肤色',
        2: '浅肤色',
        3: '中浅肤色',
        4: '中等肤色',
        5: '中深肤色',
        6: '深肤色',
      },
    },
    blogPreviewModal: {
      title: '博客预览',
      notify: '通知订阅者',
    },
    standAloneModal: {
      title: '链接预览',
      save: '保存',
      chooseLayout: '为你的链接选择布局',
      linkSettings: '链接设置',
      linkSettingsSubtitle: '跳转、外观',
      whenVisitorsClicks: '当访客点击此链接时：',
      redirect: '跳转',
      redirectText: '将访客直接引导至该 URL',
      highlight: '高亮',
      highlightText: '将访客引导至你的 UniLink 并高亮显示',
      standalone: '独立',
      standaloneText: '让你的 YouTube 链接脱颖而出，内容直接在你的页面上播放',
      cover: '封面',
      imageTab: '图片',
      videoTab: '视频',
      uploadImage: '上传图片',
      whenVisitors: '当访客选择分享的链接时：',
      compact: '紧凑视图',
      fullView: '完整视图',
      videoSound: '播放有声视频',
    },
    instagramModal: {
      title: '发送自动 Instagram 私信',
      subtitle: '当有人评论你的 IG 帖子或 Reel 时，通过私信发送此链接',
      promo: '选择你想从哪个 IG 发送',
      connect: '连接 Instagram 账户',
      added: 'Instagram 账户已添加',
      addNew: '添加新自动化',
      igContent: 'IG 内容',
      trigger: '触发条件',
      dmContent: '私信',
      linkDestination: '链接目标',
      buttonTitle: '按钮标题',
      buttonTitleTooltip: '输入按钮标题',
      directMessage: '私信',
      directMessageTooltip: '输入私信内容',
      selectPosts: '选择将触发自动私信的帖子或 Reel。',
      onePost: '某个特定帖子或 Reel',
      allPosts: '所有帖子或 Reel',
      triggerText: '当评论包含此内容时，你的私信将发送。',
      addMessage: '添加要随链接一起自动发送的消息。',
      clickLink: '当有人点击你私信中的链接时：',
      anyComment: '任意评论',
      storiesAndDms: 'Stories 与私信',
      anyMessage: '任意消息',
      specificKeywords: '含特定关键词的评论',
      sendLink: '将他们引导至你的 UniLink 并高亮显示 ',
      skipLink: '跳过 UniLink，直接引导他们',
      keywordsTitle: '含特定关键词的评论',
      keywordsText: '当评论包含或排除特定关键词时（不区分大小写），你的私信将会发送：',
      keywordsPlaceholder: '输入关键词',
      keywordsExclude: '排除关键词',
      keywordsExcludeText: '必须排除以下任意关键词',
      replyComment: '回复评论',
      replyCommentTooltip: '输入回复评论',
    },
    blockEditProduct: {
      productPreview: '缩略图',
      productDetails: '详情',
      settings: '设置',
      design: '设计',
    },
    editMenuItems: {
      overview: '概览',
      analytics: '分析',
    },
    botToken: {
      bot: '机器人',
      botTooltip: '输入你机器人的令牌',
      connect: '连接',
      token: '令牌',
    },
    rewards: {
      title: '标题',
      titleTooltip: '输入回复的标题',
      text: '文本',
      textTooltip: '输入回复的文本',
      link: '链接',
      linkTooltip: '输入回复的链接',
      code: '代码',
      codeTooltip: '输入回复的代码',
      files: '文件',
      filesTooltip: '输入回复的文件',
      removeReward: '确定要移除此回复吗？',
    },
    addRewardModal: {
      addReward: '添加回复',
      textTitle: '文本',
      textText: '通过富文本编辑器提供说明或任意文本',
      fileTitle: '文件',
      fileText: '提供文件并收集联系方式',
      linkTitle: '链接',
      linkText: '提供独家内容访问权限并收集联系方式',
      codeTitle: '代码',
      codeText: '提供独家优惠访问权限并收集联系方式',
    },
    blockEmpty: {
      isNotAdded: '尚未添加',
      itSeems: '看起来你的',
      itemsNot: '项目还没有添加。现在添加你的视频吧',
      add: '添加',
    },
    blockList: {
      add: '添加',
      item: '项目',
    },
    submitAction: {
      action: '操作（提交后）',
      actionTooltip: '选择提交后的操作',
      upload: '上传附件',
      none: '无',
      page: '显示确认页面',
      email: '发送确认邮件',
      redirect: '跳转到 URL',
    },
    blockEditItem: {
      content: '内容',
      preview: '预览',
      settings: '设置',
    },
    domainButton: {
      customizeDomain: '自定义你的域名。',
      upgradeToLink: '升级到 Link in Bio Pro 以使用自定义域名。',
    },
    coverText: {
      text: '文本',
      textTooltip: '输入封面的文本',
      description: '描述',
      descriptionTooltip: '输入封面的描述',
      textColor: '文字颜色',
    },
    itemModal: {
      edit: '编辑',
      addNew: '新增',
      item: '项目',
      update: '更新',
      add: '添加',
    },
    productSheet: {
      openFullEditor: '打开完整编辑器',
      copyLink: '复制链接',
      active: '已启用',
      notActive: '未启用',
      statistics: '统计',
      clicks: '点击',
      sales: '销量',
      revenue: '收入',
      onlyName: '只需填写名称',
      name: '名称',
      required: '必填',
      price: '价格',
      optional: '选填',
      free: '免费',
      appearance: '外观',
      cover: '封面',
      coverNote: '正方形，不小于 600×600。也可以稍后添加。',
      description: '描述',
      descriptionPlaceholder: '一句话介绍内容',
      remove: '移除',
      photo: '照片',
      enterName: '请输入名称',
      adding: '正在添加…',
    },
    viewDesign: {
      compact: '紧凑',
      card: '卡片',
      button: '按钮',
      list: '列表',
      hero: '大图',
      featured: '精选',
    },
    moveItemModal: {
      title: '将项目移动到其他页面',
      cancel: '取消',
      move: '移动',
      page: '页面',
      pageTooltip: '选择要移动到的页面',
      blocks: '板块',
      blocksTooltip: '选择要移动到的板块',
      emptyBlocks: '此页面没有所需的板块。',
    },
    limitModal: {
      title: '已达上限',
      text1: '你已达到网站上限。',
      text2: '请联系我们升级你的方案。',
      close: '关闭',
    },
    cropPicture: {
      title: '裁剪你的图片',
      cancel: '取消',
      save: '保存',
    },
    uploadFile: {
      uploadProductImage: '上传商品图片',
      coverImage: '封面图片',
      uploadImages: '此处只能上传图片',
    },
    userMediaLibrary: {
      addImage: '添加图片',
      uploadImage: '上传图片',
      orSelectFrom: '或上传',
      orSelectLink: '或粘贴链接',
      myMedia: '我的媒体',
      stockImages: '图库图片',
      gifs: 'GIF',
      icons: '图标',
      noImagesYet: '暂无图片',
      loadMore: '加载更多',
    },
    itemMenu: {
      active: '启用',
      willBeAvailable: '该项目将于以下时间可用：',
      save: '保存',
      copied: '已复制',
      copyLink: '复制链接',
      delete: '删除',
    },
    itemDesign: {
      linkColor: '链接颜色',
      gradient: '渐变',
      background: '背景',
      backgroundOpacity: '背景不透明度',
      backgroundOpacityTooltip: '拖动滑块设置背景不透明度',
      backgroundDarkness: '背景暗度',
      backgroundDarknessTooltip: '拖动滑块设置背景暗度',
      text: '文字',
      color1: '颜色 1',
      color2: '颜色 2',
      direction: '方向',
      directionTooltip: '拖动滑块设置渐变方向',
      offset: '偏移',
      offsetTooltip: '拖动滑块设置渐变偏移',
      linkHeight: '链接高度',
      linkHeightTooltip: '拖动滑块更改按钮高度',
      icon: '图标',
      iconTooltip: '为你的按钮选择图标',
      imageShape: '图片形状',
      imageShapeTooltip: '为你的链接选择图片形状',
    },
    menu: {
      linkInBio: 'Link in Bio',
      linkInBioApps: 'Link in Bio',
      posts: '帖子',
      audience: '受众',
      orders: '订单',
      marketing: '营销',
      emailMarketing: '邮件营销',
      socialPlanner: '社交规划器',
      shortLinks: '短链接',
      businessCards: '名片',
      emailSignatures: '邮件签名',
      virtualBackgrounds: '虚拟背景',
      recentProfiles: '最近的主页',
      standalonePage: '独立页面',
      soloApps: 'App in Bio',
      bots: '机器人',
      smartReply: 'Instagram 回复',
      analytics: '分析',
      settings: '设置',
      shop: '赚钱',
      publish: '发布',
      studio: '工作室',
      blog: '博客',
      qrCodes: '二维码',
      singlePages: '应用',
      forms: '表单',
      form: '表单',
      automations: '自动化',
      community: '社区',
      messages: '收件箱',
      agents: '智能助手',
      apps: '应用',
    },
    notificationsBlockSetting: {
      title: '通知',
      setUp: '设置',
      notifications: '通知',
      connect: '连接',
      telegramText: '当有人进行以下操作时接收 Telegram 通知',
      change: '更改',
      email: '邮箱',
      emailText: '当有人进行以下操作时接收邮件',
      webhook: 'Webhook',
      webhookTooltip: '添加 Webhook',
      activate: '启用',
      webhookText: '当有人进行以下操作时向第三方网站发送事件',
      webhookURL: 'Webhook URL（POST 请求）',
      error: '请输入正确的链接',
      save: '保存',
    },
    navigation: {
      content: '内容',
      pages: '页面',
      posts: '帖子',
      shop: '商店',
      blog: '博客',
      design: '设计',
      analytics: '分析',
      settings: '设置',
      apps: '应用',
      store: '商店',
    },
    headerSettings: {
      design: '设计',
      analytics: '分析',
      settings: '设置',
      editTabs: '编辑标签',
    },
    unlockModal: {
      title: '解锁 Pro 功能',
      text: '从你的 Link-in-Bio 获得更多。仅需 $5/月 — 解锁 Pro 提供的一切：',
      checkBoxTitle1: '更多板块：',
      checkBoxText1: '添加表单、商店、倒计时和媒体播放器',
      checkBoxTitle2: '高级分析：',
      checkBoxText2: '跟踪点击、浏览和受众洞察',
      checkBoxTitle3: '自定义域名：',
      checkBoxText3: '使用你自己的域名，更显专业',
      checkBoxTitle4: '内置商店：',
      checkBoxText4: '轻松销售商品并管理订单',
      checkBoxTitle5: 'SEO 工具：',
      checkBoxText5: '通过元标签、UTM 和自定义别名提升排名',
      checkBoxTitle6: '集成：',
      checkBoxText6: '与 Mailchimp、Zapier 等工具同步',
      checkBoxTitle7: '邮件营销：',
      checkBoxText7: '收集线索并发送自动化营销活动',
      checkBoxTitle8: '优先支持：',
      checkBoxText8: '随时需要都能更快获得帮助',
      upgradeToPro: '升级到 Pro',
      viewAllPlans: '查看所有方案',
    },
    profileSwitcher: {
      title: '所有主页',
      button: '添加新主页',
    },
    account: {
      signOut: '退出登录',
      createNew: '创建新的 Link in Bio',
      tryPro: '立即试用 Pro！',
      tryProText: '获得高级自定义和更深入的受众洞察，赢得更多访客！',
    },
    accountSettings: {
      title: '账户设置',
    },
    billingHistory: {
      title: '账单历史',
    },
    pages: {
      home: '首页',
      newPage: '新建页面',
      managePages: '管理页面',
    },
    blockItem: {
      actionRequired: '需要操作',
      hidden: '已隐藏 · 无人可见',
    },
    blockContent: {
      untitled: '未命名',
      clickToRename: '点击重命名副标题',
      saving: '保存中',
      saved: '已保存',
      deleteTitle: '确定要删除此板块吗？',
      cancel: '取消',
      yes: '是',
    },
    addButtonModal: {
      title: '添加操作按钮',
      close: '关闭',
      added: '已添加',
      add: '添加',
      messageTitle: '消息',
      messageText: '消息按钮让用户可以通过即时通讯联系你',
      subscribeTitle: '订阅',
      subscribeText: '订阅按钮让用户可以订阅你的邮件或即时通讯列表',
      ctaTitle: 'CTA 按钮',
      ctaText: 'CTA 是网站上引导用户执行特定操作的提示',
      cartTitle: '购物车',
      cartText: '显示购物车图标，表明访客可以在你的网站上购物',
      contactTitle: '联系方式',
      contactText: '让访客可以快速获取你的联系信息',
      qrcodeTitle: '二维码',
      qrcodeText: '显示二维码，让访客可以快速扫描并分享你的页面',
      languageTitle: '语言',
      languageText: '允许访客切换页面语言',
      searchTitle: '搜索',
      searchText: '让访客直接从页眉搜索您的商店商品',
    },
    inputMask: {
      copyLink: '复制链接',
    },
    videoLibrary: {
      addVideo: '添加视频',
      myVideos: '我的视频',
      stockVideos: '图库视频',
      pasteUrl: '粘贴 URL',
      uploadVideo: '上传视频',
    },
    createBlockModal: {
      searchTitle: '选择要添加到页面的板块',
      title: '添加到 UniLink',
      contentTitle: '内容',
      contentText: '创建和管理你的页面',
      growTitle: '线索',
      growText: '收集线索并提升互动',
      monetizeTitle: '变现',
      monetizeText: '销售商品、内容和服务',
      monetizationTitle: '赚钱与收款',
      monetizationText: '销售商品、服务并收取小费',
      socialTitle: '社交媒体内容',
      socialText: '在你的 UniLink 上分享社交媒体内容',
      toolsTitle: '增长工具',
      toolsText: '增长、管理并与你的受众建立联系',
      search: '搜索',
      all: '全部',
      allCategories: '所有分类',
      content: '内容',
      monetization: '变现',
      social: '社交',
      tools: '工具',
      header: '页头',
      headerText: '添加头像和简介',
      link: '链接',
      linkText: '选择链接布局',
      text: '文本',
      textText: '选择文本布局',
      videos: '视频',
      videosText: '选择视频类型',
      image: '图片',
      imageText: '添加图片板块',
      music: '音乐',
      musicText: '选择音乐类型',
      socialFeeds: '社交动态',
      socialFeedsText: '选择社交动态类型',
      moreContent: '更多',
      moreContentText: '添加更多内容板块',
      dataCollect: '数据收集',
      dataCollectText: '选择数据收集类型',
      form: '表单',
      formText: '选择表单类型',
      conversionTools: '互动工具',
      conversionToolsText: '添加转化板块',
      products: '商品',
      productsText: '添加商品板块',
      donation: '打赏与捐赠',
      tipsAndDonations: '打赏与捐赠',
      tipsDonationsText: '打赏和捐赠板块',
      event: '活动',
      eventText: '选择活动类型',
      quickAdd: '所有板块',
      quickAddText: '添加任意板块',
    },
    addBlockModal: {
      title: '添加到 UniLink',
      dragToAdd: '拖动以添加',
      contentTitle: '分享基础内容',
      contentText: '直接在你的 UniLink 上分享内容',
      monetizationTitle: '赚钱与收款',
      monetizationText: '销售商品、服务并收取小费',
      socialTitle: '社交媒体内容',
      socialText: '在你的 UniLink 上分享社交媒体内容',
      toolsTitle: '增长工具',
      toolsText: '增长、管理并与你的受众建立联系',
      search: '搜索',
      searchPlaceholder: '搜索内容...',
      all: '全部',
      allCategories: '所有分类',
      content: '内容',
      monetization: '变现',
      social: '社交',
      tools: '工具',
      suggestTitle: '推荐你的板块',
      suggestText: '缺少某个板块？告诉我们你想看到什么',
      suggestModalTitle: '推荐一个板块',
      suggestModalSubtitle: '描述你希望 UniLink 拥有的板块。我们会认真阅读每一个想法。',
      suggestPlaceholder: '例如：一个可同步 Google Calendar 的预约板块...',
      suggestSubmit: '发送建议',
      suggestSending: '发送中...',
      suggestSuccessTitle: '建议已发送！',
      suggestSuccess: '谢谢！我们会认真阅读每个想法，并用它们来规划产品路线。',
      suggestError: '无法发送，请重试。',
    },
    tabNavigation: {
      tabView: '标签视图',
      tabViewTooltip: '为导航选择标签视图',
      colors: '颜色',
      colorsTooltip: '选择帖子和按钮的颜色',
      tabs: '标签',
      tabsTooltip: '选择在网站导航中显示的标签',
      content: '内容',
      posts: '帖子',
      store: '商店',
      shop: '商店',
      tabsSettings: '标签导航设置',
    },
    hideLogo: {
      text: '在页面页脚显示 UniLink 标志。',
      text2: '在页面页脚显示 UniLink 标志。',
    },
    palettePreview: {
      custom: '自定义背景颜色',
      hexColor: '十六进制颜色',
      hexColorTooltip: '输入预览的十六进制颜色',
    },
    backgroundVideo: {
      insert: '插入 URL',
      upload: '上传视频',
      search: '搜索视频',
    },
    periodDropdown: {
      today: '今天',
      yesterday: '昨天',
      last7days: '过去 7 天',
      last30days: '过去 30 天',
      allTime: '所有时间',
      custom: '自定义',
    },
    subsections: {
      content: '内容',
      design: '设计',
      settings: '设置',
    },
    wrapperSettings: {
      lock: '升级到 PRO 方案',
    },
    shareModal: {
      addSocials: '添加到社交媒体',
      shareTo: '分享到',
      qrCode: '二维码',
      customizeUrl: '自定义 URL',
      goToMy: '前往我的',
      print: '你可以将专属二维码打印在',
      cards: '名片和传单上',
      download: '下载',
      copy: '复制',
      previewMobile: '在手机上预览',
      scanMobilePreview: '用手机扫描二维码以预览你的网站',
      types: {
        socials: '社交媒体',
        shareTo: '分享',
        qrCode: '二维码',
        title: '分享你的 UniLink',
        titleSocials: '将 UniLink 添加到你的社交媒体',
        titleShareTo: '分享到...',
        titleQRCode: '二维码',
        titlePreviewMobile: '在手机上预览',
      },
      socialList: {
        instagramText: '将你的 UniLink 添加到 Instagram 主页。只需复制你的 UniLink 网址，进入编辑主页，粘贴到网站字段即可。',
        facebookText:
          '将你的 UniLink 添加到 Facebook 主页。只需复制你的 UniLink 网址，进入主页的“关于”页面，点击“联系方式和基本信息”，然后点击“+ 添加网站”，将 UniLink 网址粘贴到网址字段，点击保存。',
        tikTokText:
          '将你的 UniLink 添加到 Facebook 主页。只需复制你的 UniLink 网址，进入主页的“关于”页面，点击“联系方式和基本信息”，然后点击“+ 添加网站”，将 UniLink 网址粘贴到网址字段，点击保存。',
        twitchText:
          '将你的 UniLink 添加到 Twitch 频道。只需复制你的 UniLink 网址，进入你的 Twitch 频道，点击“关于”，然后点击“编辑关于和链接设置”，向下滚动到社交链接，在第一个文本框填入 UniLink，将 UniLink 网址粘贴到第二个文本框，然后点击添加。',
        youTubeText:
          '将你的 UniLink 添加到 YouTube 频道。只需复制你的 UniLink 网址，进入你的 YouTube 频道，点击“自定义频道”，然后点击“基本信息”，在链接下添加链接标题并将 UniLink 网址粘贴到网址字段，然后点击发布。',
        linkedInText:
          '将你的 UniLink 添加到 LinkedIn 主页。只需复制你的 UniLink 网址，进入你的 LinkedIn 主页，点击铅笔图标，向下滚动到联系信息，将 UniLink 网址粘贴到网站 URL 字段，然后点击应用。',
        pinterestText: '将你的 UniLink 添加到 Pinterest 主页。只需复制你的 UniLink 网址，进入你的 Pinterest 设置，将 UniLink 网址粘贴到网站 URL 字段，然后点击保存。',
        twitterText: '将你的 UniLink 添加到 Twitter 主页。只需复制你的 UniLink 网址，进入你的主页，点击编辑主页，将 UniLink 网址粘贴到网站字段即可。',
      },
      share: {
        shareFacebook: '分享到 Facebook',
        shareLinkedIn: '分享到 LinkedIn',
        shareTwitter: '分享到 Twitter',
        shareWhatsApp: '通过 WhatsApp 分享',
        shareMessenger: '通过 Messenger 分享',
        shareEmail: '通过邮件分享',
      },
    },
  },
  popupMenu: {
    edit: '编辑页面',
    openInNewTab: '在新标签页打开',
    copyLink: '复制 URL',
    delete: '删除',
    showThumbnail: '在仪表板中显示页面缩略图',
    manageTabs: '管理标签',
  },
  tabsDashboard: {
    labelAddNewTab: '新建标签',
  },
  blocks: {
    header: {
      blockTitle: '页头',
      blockText: '自定义你的头像、添加简短简介并更新你的社交图标',
      blockShortText: '自定义你的主页',
      layout: '布局',
      layoutTooltip: '创建你想要的页头布局',
      layoutAlign: '布局对齐',
      layoutAlignTooltip: '文字对齐',
      bottomButtonsSettings: '底部按钮',
      bottomButtonsLayout: '布局',
      bottomButtonsRow: '并排',
      bottomButtonsColumn: '堆叠',
      profilePicture: '头像',
      profilePictureTooltip: '更改你的头像',
      cropMismatch: '此照片是为其他布局裁剪的。',
      adjustCrop: '调整裁剪',
      photoShapeLabel: '照片形状',
      photoShapeTooltip: '选择此布局显示方形照片还是纵向裁剪。',
      photoShapeSquare: '方形',
      photoShapeVertical: '纵向',
      coverShape: '封面形状',
      coverShapeTooltip: '选择封面的底边：直线、向下弧形或向上弧形。',
      coverShapeStraight: '直线',
      coverShapeArcDown: '向下弧形',
      coverShapeArcUp: '向上弧形',
      avatarOffsetLabel: '头像位置',
      avatarOffsetTooltip: '相对于封面边缘上下微调头像。',
      photoStyleProTitle: '解锁高级照片样式',
      photoStyleProDesc: '无背景和文字置后是 PRO 功能。',
      photoShapeCustom: '自定义',
      sliderStyleLabel: '滑块样式',
      sliderStyleTooltip: '滑动模式一次显示一张照片；相册模式显示缩略图行 — 点击缩略图切换主照片。',
      sliderStyleSwipe: '滑动',
      sliderStyleGallery: '相册',
      photoPositionLabel: '照片位置',
      photoPositionHint: '纵向取景',
      verticalCropHint: '此布局显示原始照片。选择你想展示的纵向区域。',
      verticalCropReady: '微调此布局中显示的纵向区域。',
      pickVerticalArea: '选择纵向区域',
      pictureSize: '图片尺寸',
      pictureSizeTooltip: '你可以更改图片尺寸',
      pictureHeight: '图片高度',
      pictureHeightCaption: '你可以更改图片高度',
      photoStyle: '照片样式',
      photoStyleTooltip: '按原样显示照片、移除背景，或在主体后方放置文字。',
      avatarModeOriginal: '原始',
      avatarModeCutout: '无背景',
      avatarModeLayered: '文字置后',
      overlayText: '文字',
      overlayTextPlaceholder: '你的姓名（默认）',
      overlayColor: '文字颜色',
      overlaySize: '大小',
      overlayY: '垂直位置',
      overlayEffect: '动画',
      overlayEffectNone: '无',
      overlayEffectShimmer: '微光',
      overlayEffectGlow: '发光',
      overlayEffectGradient: '渐变',
      overlayEffectSparkle: '闪烁',
      overlayUsesName: '在此布局中，文字即你的主页名称 — 它出现在你身后。请在“姓名”部分编辑。',
      cutoutGenerate: '生成抠图',
      cutoutRegenerate: '重新生成',
      cutoutUpload: '上传',
      cutoutOr: '或',
      cutoutGenerating: '生成中...',
      cutoutUploading: '上传中...',
      cutoutVideoHint: '背景移除仅适用于图片照片，不适用于视频。',
      cutoutTimeout: '背景移除耗时过长，请重试。',
      preview: '预览',
      badge: '徽章',
      badgeTooltip: '为页头添加认证徽章',
      profileBadges: '徽章',
      profileBadgesTooltip: '最多选择 3 个徽章显示在你姓名旁边',
      profileBadgesProLockHint: '升级到 PRO 以使用此徽章',
      profileBadgesAdd: '添加徽章',
      profileBadgesManage: '管理徽章',
      profileBadgesModalTitle: '为你的主页添加徽章',
      profileBadgesModalSubtitle: '展示你的成就和荣誉。',
      profileBadgesCustomCta: '上传你自己的徽章',
      profileBadgesCustomDesc: '你的自定义徽章',
      profileBadgesCustomName: '徽章名称',
      profileBadgesCustomChoose: '选择图片',
      profileBadgesCustomChange: '更改图片',
      profileBadgesCustomUploading: '上传中…',
      profileBadgesCustomAdd: '添加徽章',
      tags: '标签',
      tagsTooltip: '在你姓名下方显示分类标签（最多 5 个）',
      tagsAdd: '添加标签',
      addTags: '+ 添加标签',
      tagsEdit: '编辑标签',
      tagsCustomPlaceholder: '添加自定义标签',
      tagsCustomAdd: '添加',
      tagsSuggested: '建议分类',
      tagsSelected: '已选择',
      tagsEmpty: '暂无标签 — 从建议中选择或添加你自己的',
      tagsLimit: '最多 5 个标签',
      visibility: '可见性',
      visibilityTooltip: '显示或隐藏头像',
      cover: '封面',
      coverTooltip: '为页头封面添加图片或视频',
      addCover: '添加封面',
      image: '图片',
      video: '视频',
      positionCover: '文字和按钮位置',
      positionCoverTooltip: '拖动滑块更改位置',
      buttons: '按钮',
      block: '板块',
      videoProcessing: '视频处理中',
      vibe: '氛围',
      vibeTooltip: '添加你的氛围',
      stories: 'Stories',
      storiesTooltip: '添加你的 Stories',
      addStory: '添加 Story',
      storiesSubtitle: '为你的 Stories 添加图片或视频',
      subscribeMethod: '订阅方式',
      subscribeMethodTooltip: '选择你的订阅方式',
      subscribeLink: '订阅链接',
      subscribeLinkTooltip: '复制你的订阅链接',
      minWidth: '最小宽度',
      addVCard: '添加 vCard',
      vCard: 'vCard',
      vCardTooltip: '你可以添加关于自己的信息',
      buttonInline: '按钮内联页头',
      buttonInsideContact: '按钮置于联系方式按钮内',
      showSaveContact: '显示保存联系人',
      options: '选项',
      showBusinessCard: '显示名片',
      showBusinessCardCaption: '在此处添加“保存联系人”按钮。',
      editBusinessCard: '编辑名片',
      editContactDetails: '在名片中编辑联系方式',
      needAddContact: '你需要添加联系方式按钮',
      socialGap: '间距',
      socialGapCaption: '你可以更改间距',
      socialSize: '尺寸',
      socialSizeCaption: '你可以更改尺寸',
      icons: '图标',
      iconsTooltip: '为按钮添加图标',
      ribbonLabel: '装饰丝带',
      ribbonLabelTooltip: '在页头主区下方添加一条彩色栏',
      addTint: '添加丝带',
      ribbonTitle: '丝带',
      ribbonText: '丝带文字',
      ribbonTextPlaceholder: '例如：本月底前 8 折优惠',
      ribbonColor: '丝带颜色',
      ribbonTheme: '样式',
      ribbonThemes: {
        none: '无装饰',
        birthday: '生日',
        newyear: '新年',
        valentine: '情人节',
        halloween: '万圣节',
        summer: '夏日',
      },
      ribbonEffect: '效果',
      ribbonEffects: {
        none: '无',
        gradient: '动态渐变',
        shimmer: '微光',
        lights: '串灯',
      },
      ribbonPosition: '位置',
      ribbonPositions: {
        bottom: '页头下方',
        underPhoto: '照片下方',
      },
      ribbonRemove: '移除丝带',
      statusBadges: '动态',
      statusBadgesTooltip: '在你的页面上显示实时动态',
      addStatus: '添加动态',
      statusDisabledHint: '隐藏 · 已禁用',
      followersTitle: '关注者',
      followersCounter: '关注者计数',
      followersTooltip: '显示你已连接社交账户的合计关注者数量',
    },
    text: {
      blockTitle: '文本',
      blockText: '通用文本板块，可撰写任何内容。你可以使用所见即所得编辑器格式化文本',
      blockShortText: '通用文本板块',
      title: '标题',
      titleText: '自定义你的标题大小',
      orderOfElements: '元素顺序',
      orderOfElementsTooltip: '拖动滑块更改元素顺序',
      changeOrder: '更改顺序',
      text: '文本',
      content: '内容',
      image: '图片',
      button: '按钮',
      addButtons: '添加更多按钮',
      displayedContent: '显示的内容',
      displayedContentTooltip: '显示或隐藏内容',
      buttonLayout: '按钮布局',
      buttonLayoutTooltip: '选择垂直或水平的按钮排列',
    },
    timeline: {
      blockTitle: '时间线',
      blockText: '显示带事件的垂直时间线。每个事件可包含日期/时间、标题、描述和可选图片',
      blockShortText: '显示事件时间线',
      editItem: '编辑事件',
      title: '标题',
      titlePlaceholder: '事件标题',
      subtitle: '副标题',
      subtitlePlaceholder: '角色或所属（可选）',
      description: '描述',
      descriptionPlaceholder: '事件描述（可选）',
      startTime: '开始时间',
      endTime: '结束时间',
      startDate: '开始日期',
      endDate: '结束日期',
      showEndDate: '显示结束日期',
      showEndDateTooltip: '对于持续中的事件请关闭（例如“2023 年起在此工作”）',
      includeTime: '包含时间',
      includeTimeTooltip: '若关闭，则只显示日期不显示时间',
      image: '图片',
      imagePlaceholder: '上传头像或图标',
      imageUploadFailed: '图片无法上传。请使用“我的媒体”或粘贴链接。',
      untitled: '未命名',
      listLayout: '列表布局',
      lineColor: '线条颜色',
    },
    trust: {
      blockTitle: '信任',
      blockShortText: '分享你的合作伙伴',
      blockText: '将你所有的合作关系集中在一处。',
      titleText: '自定义你的标题大小',
      orderOfElements: '元素顺序',
      orderOfElementsTooltip: '拖动滑块更改元素顺序',
      changeOrder: '更改顺序',
      text: '文本',
      content: '内容',
      image: '图片',
      button: '按钮',
      displayedContent: '显示的内容',
      displayedContentTooltip: '显示或隐藏内容',
      enterTrustLink: '输入合作伙伴的 URL',
      enterTrustLinkTooltip: '粘贴合作伙伴的 URL',
      enterPartnerName: '输入合作伙伴名称',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: '输入描述（可选）',
      partnerLogo: '合作伙伴 Logo',
      uploadPartnerLogo: '上传你合作伙伴的 Logo',
    },
    wall: {
      blockTitle: '留言墙',
      blockShortText: '收集访客留言',
      blockText: '显示一个公开留言墙，访客可以在此留言并与你的内容互动',
    },
    'live-stream': {
      blockTitle: '直播',
      blockShortText: '在你的页面上直播',
      blockText: '向你的受众直播 — 通过我们平台原生直播，或嵌入 YouTube / Twitch',
    },
    workout: {
      blockTitle: '训练',
      blockShortText: '分享和销售训练',
      blockText: '发布结构化训练 — 含组数、次数和演示视频的动作。付费销售或免费分享',
    },
    videoFeedback: {
      blockTitle: '视频反馈',
      blockShortText: '收集视频证言',
      blockText: '收集来自你受众的简短视频证言和反馈',
    },
    'premium-inbox': {
      blockTitle: '付费收件箱',
      blockShortText: '来自粉丝的付费消息',
      blockText: '让粉丝直接向你的付费收件箱发送付费消息和请求',
    },
    'order-form': {
      blockTitle: '订单表单',
      blockShortText: '从你的页面收集订单',
      blockText: '通过可自定义的订单表单直接从你的页面收集订单',
    },
    link: {
      blockTitle: '链接',
      blockText: '为你的网站、博客、在线商店或任何其他网页引导流量',
      blockShortText: '为网站引导流量',
      addLink: '添加链接',
      addNewLink: '添加新链接',
      restrictedTitle: '{platform} 链接是 PRO 功能',
      restrictedText: '添加 {platform} 链接需要 PRO 方案。升级你的方案即可将此链接添加到页面。',
      upgradeToPro: '升级到 PRO',
      showMore: '显示更多',
      showLess: '显示更少',
      viewArchive: '查看归档',
      archivedLinks: '已归档链接',
      noArchivedLinks: '通过归档暂时不用的链接，让你的链接管理保持整洁、聚焦。',
      archiveAllUnpublished: '归档所有未发布链接',
      addFormExisting: '从现有链接添加',
      addYourLink: '将你的链接添加到分组',
      add: '添加',
      otherTypes: '操作类型',
      link: '链接',
      navigate: '导航',
      navigateTo: '导航到',
      scrollBlock: '滚动到',
      copyText: '复制文本',
      navigatePage: '页面',
      navigateProduct: '商品',
      navigateBlock: '板块',
      modal: '弹窗',
      showModal: '显示弹窗',
      modalBlock: '显示板块',
      modalItem: '显示项目',
      modalCustom: '自定义',
      document: '文档',
      privat24: 'Privat24',
      phone: '拨打电话',
      viber: '打开 Viber',
      skype: '打开 Skype',
      email: '发送邮件',
      discount: '折扣',
      smartLink: '智能链接',
      mobileApp: '深度链接',
      enterURL: '输入 URL',
      enterPrivat: '输入你的 Private Bank 卡号',
      enterPhone: '输入电话号码',
      enterViber: '输入 Viber 号码',
      enterSkype: '输入 Skype',
      enterEmail: '输入邮箱',
      enterTitle: '输入标题',
      enterCopyText: '输入要复制的文本',
      enterPromoCode: '输入优惠码',
      group: '创建分组',
      content: '内容',
      links: '链接',
      heading: '标题',
      settings: '设置',
      thumbnail: '缩略图',
      typeTooltip: '  点击将打开此链接',
      title: '标题',
      titleTooltip: '你链接的名称',
      description: '描述',
      descriptionTooltip: '可选：对链接特性、类型、颜色、尺寸等的描述。',
      label: '标签',
      labelTooltip: '添加标签名称',
      button: '按钮',
      buttonTooltip: '添加按钮名称',
      buttonText: '按钮文字',
      buttonTextTooltip: '你按钮的名称',
      buttonUrl: '按钮 URL',
      buttonUrlTooltip: '输入按钮 URL',
      addLinkToGroup: '将链接添加到分组',
      removeFromGroup: '从分组移除',
      deletePermanently: '永久删除',
      image: '图片',
      buttonBg: '按钮背景',
      postPreview: '帖子预览',
      separatorType: '分隔符类型',
      separatorTypeTooltip: '为你的按钮添加分隔符类型',
      section: '分区',
      sectionTooltip: '链接的分区',
      descriptionSeparator: '描述',
      descriptionSeparatorTooltip: '可选的分区描述',
      sectionText: '分区文字',
      linkInstant: '链接即时跳转',
      spotlight: '聚焦此链接',
      addEffect: '添加特殊效果',
      countdown: '倒计时',
      countdownTimer: '倒计时计时器',
      countdownText: '添加一个到链接可点击时的实时倒计时',
      chooseDate: '选择日期',
      chooseDateTooltip: '为你的链接选择日期',
      chooseAction: '选择操作',
      chooseActionTooltip: '为你的链接选择操作',
      addCountdown: '为链接添加倒计时',
      scheduler: '排期器',
      schedule: '排期',
      scheduleText: '为你的链接选择一个未来的日期和时间以激活',
      activateOn: '激活于',
      activateOnTooltip: '选择日期',
      deactivateOn: '停用于',
      deactivateOnTooltip: '选择日期',
      addSchedule: '添加排期',
      scheduleError: '结束日期不能早于开始日期，且开始日期不能在过去。',
      scheduleErrorPast: '激活日期不能在过去。',
      scheduleErrorPastDeactivate: '停用日期不能在过去。',
      scheduleErrorOrder: '停用日期必须在激活日期之后。',
      activatesIn: '激活倒计时',
      deactivatesIn: '停用倒计时',
      lock: '锁定',
      lockText: '访客只有满足其中一个条件才能访问此链接。',
      lockCode: '代码',
      lockCodeTitle: '解锁此链接的代码',
      lockCodeText: '访客需要输入 4 位代码才能解锁此链接',
      lockSubscribe: '订阅',
      lockSubscribeTitle: '访客必须订阅你的 UniLink 才能解锁此链接。',
      lockSubscribeText: '锁定已成功配置。',
      lockPayment: '支付',
      lockPaymentText: '锁定已成功配置。',
      price: '价格',
      priceTooltip: '添加你的商品价格',
      lockAge: '出生日期（年龄）',
      lockAgeTitle: '设置最低年龄',
      lockAgeText: '访客需通过其出生日期证明达到一定年龄才能解锁链接',
      lockAgeAlert: '锁定已成功配置。',
      lockSensitive: '敏感内容',
      lockSensitiveText: '访客必须确认此链接可能包含并非适合所有受众的内容。',
      makeLink: '使链接可付费',
      addLock: '为链接添加锁定',
      save: '保存',
      clear: '清除',
      buttonColor: '按钮颜色',
      labelColor: '标签颜色',
      background: '背景',
      imageHeight: '图片高度',
      imageHeightTooltip: '拖动滑块更改图片高度',
      buttonMinimum: '最小高度',
      buttonMinimumTooltip: '拖动滑块更改按钮高度',
      textPosition: '文字位置',
      textPositionTooltip: '选择文字的垂直位置',
      preview: '预览',
      defaultDesign: '默认设计',
      defaultDesignTooltip: '为链接设置默认设计',
      defaultDesignTitle: '请注意，此设计将应用于所有链接。',
      defaultDesignText: '你可以更改默认链接设计',
      changeDefault: '更改默认',
      applyDefault: '应用默认',
      scheduled: '已排期',
      scheduledVisible: '排期链接现已可见',
      scheduledHidden: '排期链接现已隐藏',
      linkClickable: '链接可点击倒计时',
      linkDisable: '链接停用倒计时',
      lockedBy: '锁定方式',
      items: '项目',
      doNotAnyLinks: '你还没有任何链接',
      sublinks: '子链接',
      layout: '布局',
      layoutTooltip: '选择你想要的子链接布局',
      hideGroupLink: '隐藏分组链接',
      rules: '规则',
      rulesText: '根据访客身份更改此链接的可见性。',
      rulesEmpty: '暂无条件。添加条件以控制谁能看到此链接。',
      rulesAddCondition: '添加条件',
      rulesActive: '可见性规则',
      rulesIf: '如果',
      rulesThen: '则',
      ruleTypeLocation: '位置',
      ruleTypeDevice: '设备',
      ruleTypeTime: '日期和时间',
      ruleOperatorIs: '是',
      ruleOperatorIsNot: '不是',
      ruleActionHide: '隐藏链接',
      ruleActionShow: '显示链接',
      ruleSelectLocations: '选择位置',
      ruleSearchLocations: '搜索国家/地区…',
      ruleFrom: '从',
      ruleTo: '到',
      ruleAnyTime: '任意',
    },
    'data-collect': {
      blockTitle: '数据收集',
      blockText: '收集访客的邮箱或电话号码',
      blockShortText: '收集邮箱',
      maxSize: '最多可添加 3 个渠道',
      customTerms: '自定义条款',
      customTermsTooltip: '为你的表单添加自定义条款',
      termsConditions: '条款和条件',
      text: '文本',
      subscribe: '订阅',
      title: '标题',
      titleTooltip: '输入条款和条件的标题',
      titleResultTooltip: '输入提交后的标题',
      url: 'URL',
      urlTooltip: '输入 URL',
      editItem: '编辑项目',
      placeholder: '占位提示',
      placeholderTooltip: '输入占位提示文字',
      button: '按钮',
      buttonTooltip: '激励访客输入邮箱的文字（9 折优惠、立即订阅、下载文件等）',
      successMessage: '成功消息',
      successMessageTooltip: '订阅者的成功消息',
      botURL: '机器人 URL（可选）',
      botURLTooltip: '输入你机器人的 URL',
      botToken: '机器人令牌',
      botTokenTooltip: '输入你机器人的令牌',
      rewards: '回复',
      rewardsTooltip: '为订阅者添加回复',
      addReward: '添加回复',
      thankYou: '感谢消息',
      email: {
        none: '无',
        display: '立即显示回复',
        send: '将回复发送到邮箱',
        redirect: '跳转到 URL',
      },
      phone: {
        none: '无',
        display: '立即显示回复',
        send: '将回复发送到电话',
        redirect: '跳转到 URL',
      },
      telegram: {
        none: '无',
        display: '立即显示回复',
        send: '通过 Telegram 机器人发送回复',
        redirect: '跳转到 URL',
      },
      whatsapp: {
        none: '无',
        display: '立即显示回复',
        send: '通过 WhatsApp 机器人发送回复',
        redirect: '跳转到 URL',
      },
      instagram: {
        none: '无',
        display: '立即显示回复',
        send: '通过 Instagram 机器人发送回复',
        redirect: '跳转到 URL',
      },
      messenger: {
        none: '无',
        display: '立即显示回复',
        send: '通过 Messenger 机器人发送回复',
        redirect: '跳转到 URL',
      },
      viber: {
        none: '无',
        display: '立即显示回复',
        send: '通过 Viber 机器人发送回复',
        redirect: '跳转到 URL',
      },
      connect: '连接',
      toChangeReward: '要更改回复类型，你需要先移除当前的',
      remove: '移除',
      viewTypes: '视图类型',
    },
    form: {
      blockTitle: '表单',
      blockText: '让你可以从受众中获取信息和数据',
      blockShortText: '获取信息',
      fields: '字段',
      fieldsTooltip: '向表单添加字段',
      addCustomField: '添加自定义字段',
      addItem: '添加项目',
      editItem: '编辑项目',
      type: '类型',
      typeTooltip: '选择字段类型',
      string: '简答',
      textarea: '详答',
      dropdown: '下拉菜单',
      radio: '单选',
      checkbox: '复选',
      date: '日期',
      time: '时间',
      country: '国家/地区',
      fieldName: '字段名称',
      fieldNameTooltip: '输入字段名称',
      name: '名称',
      placeholder: '占位提示',
      placeholderTooltip: '输入占位提示文字',
      required: '必填',
      requiredTooltip: '勾选此项将字段设为必填',
      value: '值',
      enterTitle: '输入标题',
      addValue: '添加值',
      delete: '删除',
      update: '更新',
      add: '添加',
      confirmationPage: '确认操作',
      confirmationPageSubtitle: '选择提交表单后的结果操作',
      successMessage: '成功消息',
      successMessageTooltip: '提交表单后的成功消息',
      thankYou: '感谢消息',
      submit: '提交',
    },
    contact: {
      blockTitle: '联系方式',
      blockText: '联系方式让用户可以直接与你沟通。添加你的电话、邮箱、即时通讯或位置',
      blockShortText: '与用户沟通',
      addNewContact: '添加新联系方式',
      newContact: '新联系方式',
      friendlyName: '友好名称',
    },
    faq: {
      blockTitle: '常见问题',
      blockText: '常见问题 — 用于呈现用户可能提出的典型问题及其答案的列表',
      blockShortText: '常见问题',
      addNewItem: '添加新项目',
      editItem: '编辑项目',
      title: '标题',
      titleTooltip: '输入标题',
      description: '描述',
      descriptionTooltip: '输入描述',
      update: '更新',
      add: '添加',
      howToFind: '如何找到我们',
      view: '视图',
      viewTooltip: '选择常见问题的显示方式',
      feed: '信息流',
      slider: '滑块',
      emptyTitle: '你还没有任何项目',
      emptyText: '添加你的第一个问题来填充此板块。',
    },
    ama: {
      blockTitle: '有问必答',
      blockShortText: '回答粉丝的提问',
      blockText: '让你的受众提问，并直接在你的页面上回答',
    },
    feature: {
      blockTitle: '特色',
      blockText: '带图片的文本区，向用户说明为什么你的业务是最佳选择',
      blockShortText: '告诉用户原因',
      title: '标题',
      titleTooltip: '更改项目标题',
      description: '描述',
      descriptionTooltip: '更改项目描述',
    },
    highlight: {
      blockTitle: '精选',
      blockText: '用缩略图突出最重要的链接（最多 3 个）',
      blockShortText: '突出最重要的',
      title: '标题',
      titleTooltip: '更改项目标题',
      url: 'URL',
      urlTooltip: '更改项目 URL',
    },
    banner: {
      blockTitle: '横幅',
      blockText: '展示图片、视频或你的最新商品，让它脱颖而出。你可以添加 CTA 按钮引导用户完成你的目标转化',
      blockShortText: '展示图片、视频',
      height: '高度',
      heightTooltip: '更改横幅高度',
    },
    slider: {
      blockTitle: '滑块',
      blockText: '图片轮播，让你可以展示图片内容并添加不同功能',
      blockShortText: '图片轮播',
      image: '图片',
      imageTooltip: '你相册的图片',
      addText: '添加文字',
      title: '标题',
      titleTooltip: '你幻灯片的标题',
      titleSize: '标题大小',
      titleSizeTooltip: '选择大小以便更好阅读',
      description: '描述',
      descriptionTooltip: '你幻灯片的描述',
      textColor: '文字颜色',
      addButton: '添加按钮',
      url: 'URL',
      urlTooltip: '你图片的 URL',
      button: '按钮',
      buttonTooltip: '你按钮的标题',
      buttonText: '按钮文字',
      buttonColor: '按钮颜色',
      height: '高度',
      heightTooltip: '更改幻灯片高度',
      view: '视图',
      viewTooltip: '为滑块选择视图',
      auto: '自动',
      square: '方形',
      rectangle: '矩形',
      single: '单张',
      multi: '多张',
    },
    gallery: {
      blockTitle: '相册',
      blockText: '图片轮播，让你可以展示图片内容',
      blockShortText: '图片轮播',
      image: '图片',
      imageTooltip: '你相册项目的图片',
      layout: '布局',
      layoutTooltip: '为相册选择布局',
      feed: '信息流',
      slider: '滑块',
    },
    blog: {
      blockTitle: '博客',
      blockText: '创建你帖子的博客',
      blockShortText: '创建博客',
      writeYourStory: '撰写你的故事',
      shortDescription: '简短描述',
      shortDescriptionTooltip: '你博客的可选描述',
      description: '描述',
    },
    map: {
      blockTitle: '地图',
      blockText: '添加 Google 地图，帮助用户导航到你的本地商家',
      blockShortText: '添加 Google 地图',
      buttonText: '按钮文字',
      buttonTextTooltip: '选择第二种视图时会出现该按钮',
      text: '文本',
      addAddress: '添加另一个地址',
      address: '地址',
      addressTooltip: '例如从 Google 地图粘贴地址',
      googleMap: 'Google 地图（嵌入代码）',
      googleMapTooltip: '从 Google 地图粘贴嵌入代码',
      howToFind: '如何找到嵌入代码',
      incorrectCode: '嵌入代码不正确。',
      moreInfo: '更多信息',
      code: '代码',
      addressSettings: '地址设置',
      addressContent: '添加 URL、标题和按钮文字或图标',
      title: '标题',
      titleTooltip: '你地址的名称',
      url: 'URL',
      urlTooltip: '例如从 Google 地图粘贴地址 URL',
      directionText: '导航文字',
      directionTextTooltip: '面向用户的行动号召文字',
    },
    footer: {
      blockTitle: '页脚',
      blockText: '页面最底部的内容区。你可以添加联系信息、社交媒体图标和邮箱注册表单',
      blockShortText: '底部内容区',
      addBlock: '添加板块',
      blockType: '板块类型',
      blockTypeTooltip: '选择板块类型',
      addBlockTitle: '板块标题',
      addBlockTitleTooltip: '选择板块标题',
      faq: '常见问题',
      'data-collect': '数据收集',
      contact: '联系方式',
      pages: '页面',
      payments: '支付',
      social: '社交',
      cancel: '取消',
      add: '添加',
      None: '无',
      text: '文本',
      link: '链接',
      image: '图片',
      divider: '分隔线',
      linkViewLabel: '布局',
      linkViewTooltip: '链接的排列方式',
      linkViewSingle: '堆叠',
      linkViewRow: '成行排列',
      linkItemsLabel: '链接',
      linkItemsTooltip: '最多添加 5 个链接（例如隐私政策、条款）',
      linkLabelPlaceholder: '标签',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ 添加链接',
      alignLabel: '对齐',
      alignTooltip: '水平对齐',
      alignLeft: '左',
      alignCenter: '居中',
      alignRight: '右',
      imageLabel: '图片',
      imageTooltip: '上传 Logo 或图片',
      imageLinkLabel: '链接（可选）',
      imageLinkTooltip: '使图片可点击',
      dividerLabel: '分隔线类型',
      dividerTooltip: '一条线或一段空白',
      dividerLine: '线条',
      dividerSpace: '空白',
      picker: {
        subtitle: '选择要添加到页脚的元素',
        configureSubtitle: '配置并将其添加到你的页脚',
        back: '返回',
        saveButton: '保存',
        availableTitle: '可添加',
        addedTitle: '已添加',
        addedLabel: '已添加',
        addButton: '添加板块',
        linkTitle: '链接',
        linkSub: '指向任意 URL 的按钮',
        socialTitle: '社交',
        socialSub: '你社交主页的图标',
        textTitle: '文本',
        textSub: '标题或段落',
        pagesTitle: '页面',
        pagesSub: '链接到嵌套子页面',
        paymentsTitle: '支付',
        paymentsSub: '接受的支付方式',
        imageTitle: '图片',
        imageSub: 'Logo 或图片',
        dividerTitle: '分隔线',
        dividerSub: '一条线或间距',
        faqTitle: '常见问题',
        faqSub: '常见问题解答',
        dataCollectTitle: '数据收集',
        dataCollectSub: '邮箱注册表单',
        contactTitle: '联系方式',
        contactSub: '联系详情',
        importMode: '从板块导入',
        manualMode: '手动添加',
        noContactsToImport: '无可导入的联系方式 — 请手动添加。',
        noSocialsToImport: '无可导入的社交图标 — 请手动添加。',
        manualItemsLabel: '项目',
        manualItemsTooltip: '选择一种类型并输入其值。',
        contactValuePlaceholder: '@用户名 / 邮箱 / 电话',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ 添加更多',
      },
      faqText: '你可以在常见问题板块中编辑常见问题。点击此处即可跳转',
      socialText: '你可以在页头板块中编辑社交图标。点击此处即可跳转',
      dataCollectText: '你可以在数据收集板块中编辑数据收集。点击此处即可跳转',
      contactText: '你可以在联系方式板块中编辑联系方式。点击此处即可跳转',
      contactDesign: {
        editSource: '在联系方式板块中编辑联系方式本身 —',
        variantLabel: '样式',
        variantList: '列表',
        variantButton: '按钮',
        shapeLabel: '形状',
        shape_square: '方形',
        shape_rounded: '圆角',
        shape_pill: '胶囊',
        widthLabel: '宽度',
        widthFull: '全宽',
        widthHalf: '半宽',
        widthHalfStacked: '半列',
        borderLabel: '边框',
        borderOn: '开',
        borderOff: '关',
        borderColorLabel: '边框颜色',
      },
      pagesText: '你可以在网站上添加新页面',
      paymentsText: '将显示支付方式',
      showOnAllpages: '在所有页面显示',
      layout: '布局',
      splitImage: '侧边图片',
      footerText: '来自首页的页脚当前已启用。',
      editSocialIcons: '你可以在页头部分编辑社交图标。点击此处即可跳转',
      editSubscribe: '你可以在订阅部分编辑订阅。点击此处即可跳转',
      editContacts: '你可以在联系方式部分编辑联系方式。点击此处即可跳转',
      editFrequently: '你可以在常见问题部分编辑常见问题。点击此处即可跳转',
    },
    'chat-ai': {
      blockTitle: 'AI 聊天',
      blockShortText: '与 AI 聊天',
      blockText: '与 AI 聊天',
      suggestionsTitle: '建议',
      suggestionsSubtitle: '快捷提示',
    },
    custom: {
      blockTitle: '自定义',
      blockShortText: 'AI 驱动的板块',
      blockText: '描述一个迷你交互式应用，AI 将为你生成',
    },
    shop: {
      blockTitle: '商店',
      blockText: '添加你的商品列表',
      blockShortText: '添加你的商品',
      view: '视图',
      cardLayout: '卡片布局',
      cardLayoutTooltip: '展示模式将每个商品呈现为详细的销售卡片，每行一个',
      standardCards: '标准',
      showcaseCards: '展示',
      products: '商品',
      categories: '分类',
      featured: '精选',
    },
    digital: {
      blockTitle: '数字商品',
      blockText: '销售数字下载内容：PDF、表格、模板、独家内容',
      blockShortText: '销售数字内容',
    },
    podcast: {
      blockTitle: '播客',
      blockText: '推广你的播客',
      blockShortText: '推广你的播客',
    },
    'page-list': {
      blockTitle: '页面列表',
      blockText: '创建你的列表页面',
      description: '描述',
      blockShortText: '创建你的列表页面',
      addNewPageItem: '添加页面链接',
    },
    appointment: {
      blockTitle: '预约',
      blockText: '让访客在你的日历上预约时间',
      blockShortText: '让访客预约',
    },
    service: {
      blockTitle: '服务',
      blockText: '当有人向你提交请求时，你将收到邮件通知',
      blockShortText: '接收邮件',
    },
    requests: {
      blockTitle: '服务',
      blockText: '当有人向你提交请求时，你将收到邮件通知',
      blockShortText: '接收邮件',
    },
    tips: {
      blockTitle: '打赏',
      blockText: 'UniLink 让支持变得有趣又简单。只需轻点几下，你的粉丝就能付款并留言',
      blockShortText: '让支持变有趣',
    },
    tip: {
      blockTitle: '打赏',
      blockText: 'UniLink 让支持变得有趣又简单。只需轻点几下，你的粉丝就能付款并留言',
      blockShortText: '让支持变有趣',
    },
    donation: {
      blockTitle: '捐赠',
      blockText: 'UniLink 让支持变得有趣又简单。只需轻点几下，你的粉丝就能付款并留言',
      blockShortText: '让支持变有趣',
    },
    course: {
      blockTitle: '课程或教程',
      blockText: '让访客在你的日历上预约时间',
      blockShortText: '让访客预约',
    },
    event: {
      blockTitle: '活动或门票',
      blockText: '让受众参加你的活动',
      blockShortText: '让受众参加',
    },
    menu: {
      blockTitle: '菜单',
      blockText: '创建带价格的独特菜单',
      blockShortText: '创建独特菜单',
    },
    recipe: {
      blockTitle: '食谱',
      blockText: '分享含食材、步骤和照片的食谱',
      blockShortText: '分享食谱',
    },
    booking: {
      blockTitle: '预订',
      blockText: '让访客预订你的空间',
      blockShortText: '让访客预订',
      name: '名称',
      nameCaption: '输入空间名称',
      description: '描述',
      descriptionCaption: '此空间的简短描述',
      rentalType: '租赁类型',
      rentalTypeCaption: '例如：公寓、汽车、办公室',
      duration: '时长',
      durationCaption: '例如：每天、每周、每月',
      price: '价格',
      priceCaption: '此空间的基础价格',
      oldPrice: '原价',
      oldPriceCaption: '可选的原价',
      rating: '评分',
      ratingCaption: '平均评分（可选）',
      label: '标签',
      labelCaption: '简短徽章，如 HOT 或 NEW',
      image: '图片',
      imageCaption: '为此空间上传封面图片',
      location: '位置',
      locationCaption: '城市、区域或地址',
      capacity: '容量（人数）',
      capacityCaption: '最大人数',
      rooms: '房间与面积',
      roomsCaption: '卧室、卫生间和面积',
      bedrooms: '卧室',
      bathrooms: '卫生间',
      areaSqM: '面积（m²）',
      minStay: '最短入住（天）',
      minStayCaption: '预订的最少天数',
      requiresDeposit: '需要押金',
      depositAmount: '押金金额',
      depositAmountCaption: '确认预订的预付押金',
      noSmoking: '禁止吸烟',
      noPets: '禁止携带宠物',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: '停车位',
      amenitiesKitchen: '厨房',
      amenitiesHeating: '暖气',
      amenitiesAC: '空调',
      amenitiesPool: '泳池',
      amenitiesSauna: '桑拿',
      amenitiesRestrooms: '洗手间',
      validationNameRequired: '名称为必填',
      validationPriceRequired: '价格必须为非负数',
      validationDepositRequired: '启用押金时押金金额为必填',
      validationCapacityNumber: '容量必须为非负数',
      validationOldPriceNumber: '原价必须为非负数',
      brand: '品牌',
      brandCaption: '汽车品牌，例如 Tesla',
      model: '型号',
      modelCaption: '汽车型号，例如 Model 3',
      year: '年份',
      yearCaption: '生产年份',
      color: '颜色',
      colorCaption: '外观颜色，例如黑色',
      fuelType: '燃料类型',
      fuelTypeCaption: '汽油、柴油、电动、混动等',
      transmission: '变速箱',
      transmissionCaption: '自动或手动',
      seatCount: '座位数',
      seatCountCaption: '车内座位数量',
      edit: '编辑项目',
      add: '添加项目',
    },
    membership: {
      blockTitle: '会员',
      blockText: '创建免费或付费的内容订阅',
      blockShortText: '创建订阅',
    },
    pricing: {
      blockTitle: '定价',
      blockText: '创建带价格的独特菜单',
      blockShortText: '创建独特菜单',
      name: '名称',
      nameTooltip: '输入你的商品名称',
      pricingPlanName: '价格方案名称',
      pricingPlanNameTooltip: '输入你的价格方案名称',
      description: '描述',
      descriptionTooltip: '输入你的商品描述',
      pricingPlanDescriptionTooltip: '输入你的价格方案描述',
      priceValue: '价格值',
      priceUnit: '价格单位',
      label: '标签',
      labelTooltip: '输入你价格方案的标签',
      orderButtonText: '下单按钮文字',
      orderButtonTextDescriptionTooltip: '输入你价格方案的下单按钮文字',
      orderButtonLink: '下单按钮链接',
      orderButtonLinkDescriptionTooltip: '输入你价格方案的下单按钮链接',
      subtitle: '副标题',
      subtitleTooltip: '输入你的商品副标题',
      price: '价格',
      priceTooltip: '输入你的商品价格',
      pricingTiers: '价格等级',
      pricingTiersTooltip: '输入你的商品价格等级',
      addPriceValue: '添加更多价格',
      group: '分组',
      groupTooltip: '选择你的商品分组',
      image: '图片',
      imageTooltip: '为你的商品上传图片',
      unit: '价格单位',
      unitTooltip: '输入你的价格单位',
      addUnitTitle: '价格单位',
      addPriceUnitValue: '添加更多价格单位',
      addUnitButtonText: '保存',
      button: '按钮',
      buttonTooltip: '为你的商品添加按钮',
      buttonAddText: '+ 添加按钮',
      buttonModalTextField: '按钮文字',
      buttonModalTextFieldTooltip: '输入按钮文字',
      buttonModalURLField: '按钮 URL',
      buttonModalURLFieldTooltip: '输入按钮 URL',
      buttonModalTitle: '添加按钮',
      groups: {
        title: '分组',
        subtitle: '添加、编辑和删除分组',
        groups: '分组',
        groupsTooltip: '添加、编辑和删除分组',
        addNewGroup: '添加新分组',
        newGroup: '新分组',
        titleGroup: '标题',
        titleGroupTooltip: '输入你的分组标题',
        descriptionGroup: '描述',
        descriptionGroupTooltip: '输入你的分组描述',
      },
    },
    menuBlock: {
      title: '菜单',
      subtitle: '创建含项目和价格的菜单',
      add: '添加新项目',
      edit: '编辑项目',
      name: '名称',
      nameCaption: '输入项目名称',
      description: '描述',
      descriptionCaption: '输入简短描述',
      ingredients: '食材',
      ingredientsCaption: '列出食材或成分',
      price: '价格',
      priceCaption: '输入价格',
      weight: '重量（g）',
      weightCaption: '输入以克为单位的重量',
      calories: '热量（kcal）',
      caloriesCaption: '输入以千卡为单位的热量',
      label: '标签',
      labelCaption: '输入标签文字',
      labelColor: '标签颜色',
      labelColorCaption: '选择标签背景颜色',
      image: '图片',
      imageCaption: '为你的项目上传图片',
      available: '可供订购',
      visible: '在页面上可见',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: '展示来自 OpenSea 平台或你个人钱包的 NFT',
      blockShortText: '展示 NFT',
    },
    wallet: {
      wallet: '钱包',
      blockTitle: '银行/加密钱包',
      blockText: '展示你的信用卡或比特币钱包，方便用户复制以转账',
      blockShortText: '展示你的钱包',
      title: '标题',
      titleTooltip: '你钱包的标题',
      walletNumber: '钱包地址',
      walletNumberTooltip: '粘贴你的钱包地址',
      icon: '图标',
      iconTooltip: '为你的钱包设置图标',
      card: '卡片',
      bank: '银行',
      crypto: '加密货币',
      transfer: '转账',
      paymentLink: '支付链接',
      cardNumber: '卡号',
      cardNumberTooltip: '粘贴你的卡号',
      cardHolder: '持卡人',
      cardHolderTooltip: '输入你的持卡人姓名',
      bankAccountDetails: '银行账户详情',
      bankAccountDetailsTooltip: '输入你的银行账户详情',
      walletAddress: '钱包地址',
      walletAddressTooltip: '输入你的钱包地址',
      network: '网络',
      networkTooltip: '输入你的网络',
      publicKey: '公钥',
      publicKeyTooltip: '输入你的公钥',
      providerName: '服务商名称',
      providerNameTooltip: '输入你的服务商名称',
      link: '链接',
      linkTooltip: '输入你的链接',
      serviceName: '服务名称',
      serviceNameTooltip: '输入你的服务名称',
      email: '邮箱',
      emailTooltip: '输入你的邮箱',
      phone: '电话',
      phoneTooltip: '输入你的电话',
      username: '用户名',
      usernameTooltip: '输入你的用户名',
      fullName: '全名',
      fullNameTooltip: '输入你的全名',
      referenceNumber: '参考编号',
      referenceNumberTooltip: '输入你的参考编号',
      country: '国家/地区',
      countryTooltip: '输入你的国家/地区',
      transferProvider: '转账服务商',
      transferProviderTooltip: '输入你的转账服务商',
      cryptoCurrency: '加密货币',
      cryptoCurrencyTooltip: '输入你的加密货币',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: '展示你最好的 Instagram 媒体和视频，或通过可购物的 Instagram 动态销售商品',
      blockShortText: '你最好的 Instagram 媒体',
      blockConnectTitle: 'Instagram 未连接',
      blockConnectText: '看起来你的 Instagram 商品还没有导入。现在连接你的账户',
      blockConnectButton: '添加 Instagram',
      emptyList: '你还没有 Instagram 媒体。',
      addInstagramUsername: '添加 Instagram 用户名',
      username: '用户名',
      downloadTakes: '下载最多需要 2 分钟',
      displayPost: '在你的网站上显示帖子',
      view: '视图',
      redirect: 'URL 跳转',
      text: '文字和按钮',
      actionType: '操作类型',
      url: 'URL',
      openInNewTab: '在新标签页打开',
      delete: '删除',
      cancel: '取消',
      save: '保存',
      editMedia: '编辑媒体',
      title: '标题',
      automation: '自动化',
      automationText: '使用 Autopilot 功能实现账户自动化',
      autopilot: 'Autopilot',
      autopilotTooltip: '上传带示例说明文字的帖子，你的商品标签/链接将自动生成',
      switchTitle: '自动识别标题、价格、链接',
      sampleCaption: '示例说明文字：#49.99 #NiceDress https://google.com',
      integrations: '集成',
      integrationsText: '将 Instagram 添加到你的网站',
      connectInstagram: '连接 Instagram',
      connectInstagramText: '连接你的 Instagram 账户，以展示你选择的帖子或 Reel。',
      selectAccount: '选择账户',
      connectNewInstagram: '连接新的 Instagram 账户',
      continue: '继续',
      disconnectInstagram: '断开 Instagram 连接',
      addTag: '添加标签',
      tagClickHint: '点击图片以放置标签',
      tagPositionSet: '位置已设置。请在下方填写详情。',
      tagTypeLink: '链接',
      tagTypeProduct: '商品',
      tagLabel: '标签',
      tagSelectProduct: '选择商品',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: '展示你最好的 TikTok 视频，或通过可购物的 TikTok 动态销售商品',
      blockShortText: '你最好的 TikTok 视频',
      addTikTok: '添加 TikTok 账户',
      individualVideo: '单个视频',
      videoCollection: '视频合集',
      add: '添加',
      blockConnectTitle: 'TikTok 未连接',
      blockConnectText: '看起来你的 TikTok 商品还没有导入。现在连接你的账户',
      blockConnectButton: '连接 TikTok',
      enterUsername: '输入用户名',
      enterVideo: '输入 TikTok 视频 URL',
      emptyList: '你还没有 TikTok 媒体。',
      editMedia: '编辑媒体',
      addTikTokVideo: '添加 TikTok 视频',
      displayPost: '在你的网站上显示帖子',
      delete: '删除',
      cancel: '取消',
      save: '保存',
      integrations: '集成',
      integrationsText: '将 TikTok 添加到你的网站',
      connectTikTok: '连接 TikTok',
      disconnectTikTok: '断开 TikTok 连接',
      individualText: `你无法将 TikTok 账户连接到此类型的板块（'individual'）。`,
      individualText2: '请改为添加单个 TikTok 视频。',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: '在你的页面上展示 YouTube 视频或直播。在 YouTube 视频上标记商品',
      blockShortText: '展示 YouTube 视频',
      enterYouTubeLink: '输入 YouTube URL',
      enterYouTubeLinkTooltip: '粘贴 YouTube URL',
    },
    overview: {
      blockTitle: '概览',
      blockText: '在你的页面上展示视频或直播。在视频上标记商品',
      blockShortText: '在视频上标记商品',
    },
    video: {
      blockTitle: '视频',
      blockText: '在你的页面上展示视频或直播。在视频上标记商品',
      blockShortText: '展示视频',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: '在你的 UniLink 页面上显示你的推文以提升互动',
      blockShortText: '显示你的推文',
      twitterURL: 'Twitter URL',
      twitterURLTooltip: '添加来自 Twitter 的 URL 以生成嵌入代码',
      enterTwitterURL: '输入 Twitter URL',
    },
    music: {
      blockTitle: '音乐',
      blockText: '嵌入 Spotify、SoundCloud 歌曲、播放列表，或上传你自己的音频文件',
      blockShortText: '添加你的音乐',
      brand: '品牌',
      brandTooltip: '选择添加音乐的类型',
      url: 'URL',
      embed: '嵌入代码',
      custom: '自定义',
      musicUrl: '音乐 URL',
      musicUrlTooltip: '输入音乐 URL',
      embedCodeTitle: '嵌入代码',
      embedCodeTooltip: '从所选音乐平台粘贴你歌曲的嵌入代码',
      audioFile: '音频文件',
      uploadAudios: '此处只能上传音频',
      title: '标题',
      titleTooltip: '输入你音乐的标题',
      artist: '艺术家',
      artistTooltip: '输入你音乐的艺术家',
      audioFileTitle: '音频文件',
      audioFileTooltip: '你音频文件的名称',
      coverImage: '封面图片',
      coverImageTooltip: '为你的音乐上传图片',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: '在你的页面上嵌入 Twitch 视频或直播',
      blockShortText: '嵌入 Twitch 视频',
      twitchURL: 'Twitch URL',
      twitchURLTooltip: '粘贴频道 URL 或频道名称',
      twitchTV: 'twitch.tv/...',
      displayTwitch: '显示我的 Twitch 频道',
      displayChat: '同时显示我的 Twitch 频道和聊天',
    },
    splash: {
      blockTitle: '启动屏',
      blockText: '在网站加载前显示带文字和按钮的全屏横幅，用于推广任何商品或活动',
      blockShortText: '全屏横幅',
    },
    promo: {
      blockTitle: '促销栏',
      blockText: '用于展示促销信息的醒目栏',
      blockShortText: '突出你的促销',
    },
    welcome: {
      blockTitle: '欢迎消息',
      blockText: '撰写促使访客开始聊天的欢迎消息。它会在页面底部弹出，欢迎访客并提供帮助',
      blockShortText: '撰写欢迎消息',
    },
    review: {
      blockTitle: '评价',
      blockText: '评价帮助客户更多地了解商品并判断是否适合自己',
      blockShortText: '评价帮助客户',
      name: '姓名',
      nameTooltip: '输入评价者姓名',
      comment: '评论',
      commentTooltip: '输入评价者评论',
      date: '日期',
      dateTooltip: '输入评价日期',
      rate: '评分',
      rateTooltip: '设置评价评分',
      image: '图片',
      imageTooltip: '上传评价者图片',
    },
    coupon: {
      blockTitle: '优惠券',
      blockText: '在线优惠券指可在网站上兑换的折扣码或编号',
      blockShortText: '在线优惠券',
    },
    timer: {
      blockTitle: '计时器',
      blockText: '倒计时计时器是页面上的虚拟时钟，从某个数字或日期倒数，以指示活动或优惠的开始或结束',
      blockShortText: '倒计时计时器',
    },
    outfit: {
      blockTitle: '穿搭',
      blockText: '创建你自己的商品列表',
      blockShortText: '创建商品列表',
    },
    spacer: {
      blockTitle: '间隔',
      blockText: '为你的页面添加一些垂直空白',
      blockShortText: '添加一些空白',
    },
    html: {
      blockTitle: 'HTML 代码',
      blockText: '你可以将自己的 HTML 代码粘贴到 UniLink 页面。HTML 是用于创建网页的标准标记语言，支持 iframe、区块、段落和链接。',
      blockShortText: '粘贴你自己的 HTML',
      markupCode: '标记代码',
      markupCodeTooltip: '粘贴你 HTML 的标记代码',
      strippedWarning: '显示时出于安全考虑已移除：',
    },
    unlock: {
      blockTitle: '解锁',
      blockText: '你可以将解锁内容添加到 UniLink 页面。',
      blockShortText: '粘贴你的可解锁文件',
    },
    file: {
      blockTitle: '文件',
      blockText: '此板块让你可以上传和分享文档、图片或音频等文件。访客可以直接从你的页面查看或下载它们。',
      blockShortText: '上传和分享你的文件。',
      addNewItem: '添加新文件',
      editFile: '编辑文件',
      fileName: '输入文件名',
    },
    stat: {
      blockTitle: '统计',
      blockText: '此板块让你可以展示关于页面的关键洞察，如浏览量、访客或互动。它帮助你监控受众并了解页面表现。',
      blockShortText: '为你的页面添加统计。',
      addNewItem: '添加新统计',
      editItem: '编辑统计',
      statName: '输入统计名称',
      statValue: '输入统计数值',
      statDescription: '输入统计描述',
      statItemFields: '选择要显示的字段。',
      feed: '信息流',
      slider: '滑块',
      titleSize: '标题大小',
      subtitleTitleSize: '你可以更改标题大小',
    },
    listing: {
      blockTitle: '列表',
      blockText: '展示带图片、详情和价格的房产或物品列表。',
      blockShortText: '为你的页面添加列表。',
    },
    rental: {
      blockTitle: '租赁',
      blockText: '列出租赁房产或物品，含各时段的可用性和价格。',
      blockShortText: '为你的页面添加租赁。',
    },
    'single-product': {
      blockTitle: '单个商品',
      blockText: '展示带图片、描述和购买按钮的单个商品。',
      blockShortText: '展示一个商品。',
    },
    team: {
      blockTitle: '团队',
      blockText: '用照片、姓名、角色和社交链接介绍你的团队成员。',
      blockShortText: '展示你的团队。',
    },
    timetable: {
      blockTitle: '课程表',
      blockText: '显示含课程、活动或场次的每周日程表。',
      blockShortText: '添加每周日程表。',
    },
  },
  themeTokens: {
    title: '主题样式',
    subtitle: '排版、圆角和间距',
    typography: '排版',
    corners: '圆角',
    density: '密度',
  },
  advancedDesign: {
    title: '高级',
    subtitle: '精调每个部分',
    slot_title: '标题',
    slot_description: '描述',
    slot_label: '小标签',
    fontSize: '字号',
    fontWeight: '字重',
    textTransform: '大小写',
    textAlign: '对齐',
    color: '颜色',
  },
  layoutPicker: {
    title: '布局',
    tooltip: '选择项目的排列方式',
    layout_list: '列表',
    layout_grid: '网格',
    layout_cards: '卡片',
  },
  importDesign: {
    title: '导入设计',
    subtitle: '从截图重现设计',
    upload: '上传截图',
    extracting: '分析中…',
    apply: '应用到页面',
    applying: '应用中…',
    blocksCount: '+{n} 个板块',
    applied: '设计已应用 — 添加了 {n} 个板块',
  },
};
